{
  "account_is_inactive": "Il tuo account è inattivo",
  "addons_email_marketing": "Email marketing",
  "addons_email_marketing_description": "Crea newsletter, invia campagne mirate e tieni traccia dei risultati. Organizza i contatti in liste e segmenti. Acquisisci nuovi iscritti con form di lead generation e scegli tra centinaia di template responsive e pronti all’uso.",
  "addons_email_marketing_lower": "<p>Registrati ora per:</p><ul><li><strong>Creare</strong>, <strong>inviare</strong> e <strong>analizzare campagne mirate</strong>;</li><li>Organizzare i tuoi <strong>iscritti in liste e segmenti</strong>;</li><li>Far crescere la tua mailing list con <strong>form di lead generation</strong> e <strong>moduli pop-up o inline</strong> da inserire nel tuo sito;</li><li>Scegliere tra <strong>700+ template gratuiti</strong>, completi di design responsive e contenuti pronti all’uso;</li><li>Rispettare la normativa GDPR e CAN-SPAM Act.</li></ul><p><a href=\"https://emailchef.com/it/caratteristiche/\" target=\"_blank\">Scopri di più</a> sul servizio di email marketing.</p>",
  "addons_email_marketing_tryitforfree": "Provalo Gratis!",
  "addons_email_marketing_upper": "<p>Crea le tue newsletter con un servizio di email marketing professionale e semplice da usare. I server di TurboSMTP ti garantiranno i <strong>migliori tassi di consegna</strong>.<p>",
  "addons_email_validator": "Pulizia liste",
  "addons_email_validator_description": "Un file caricato può contenere solo un indirizzo email per riga. I formati permessi sono csv e txt. Seleziona un file da caricare.",
  "addons_emailmarketing_title": "Email marketing",
  "addons_title": "Addon",
  "analytics_average_click": "Ritardo dei click",
  "analytics_average_click_description": "Tempo medio intercorso tra l’apertura della mail e i click sui link interni",
  "analytics_average_first": "Tempo di apertura",
  "analytics_average_first_description": "Tempo medio intercorso tra la consegna e l’apertura del messaggio",
  "analytics_average_opens": "Tasso di apertura medio delle email",
  "analytics_average_opens_description": "Numero medio delle volte in cui il tuo messaggio è stato visualizzato",
  "analytics_chart_frequency_d": "Giornaliero",
  "analytics_chart_frequency_h": "Orario",
  "analytics_chart_frequency_m": "Mensile",
  "analytics_chart_frequency_w": "Settimanale",
  "analytics_charts": "Grafici",
  "analytics_clicks_title": "Non sono presenti dati per questa sezione",
  "analytics_date": "Data",
  "analytics_description_clicks_empty": "Non sono stati trovati click.",
  "analytics_description_empty": "Non ci sono dati per il periodo selezionato",
  "analytics_event_bounce": "Bounce",
  "analytics_event_clicks": "Cliccata",
  "analytics_event_delivered": "Consegnata",
  "analytics_event_drop": "Scartata",
  "analytics_event_opens": "Aperta",
  "analytics_event_queued": "In coda",
  "analytics_event_sent": "Consegnata",
  "analytics_event_spam": "Spam",
  "analytics_event_unsubscribes": "Disiscrizione",
  "analytics_events": "Eventi",
  "analytics_events_all": "Tutti",
  "analytics_events_bounce": "Bounce",
  "analytics_events_bounce_tooltip": "Percentuale e numero di email respinte dai server dei destinatari",
  "analytics_events_bounces": "Bounces",
  "analytics_events_clicks": "Click",
  "analytics_events_clicks_tooltip": "Percentuale e numero di destinatari che hanno cliccato su almeno un link nel tuo messaggio",
  "analytics_events_delivered": "Consegnate",
  "analytics_events_delivered_tooltip": "Percentuale e numero di messaggi consegnati ai tuoi destinatari",
  "analytics_events_drop": "Scartate",
  "analytics_events_drop_tooltip": "Email che non sono state inviate poiché in passato hanno generato bounce, spam o disiscrizioni. Questi destinatari sono elencati nella sezione \"Blacklist\"",
  "analytics_events_opens": "Aperte",
  "analytics_events_opens_tooltip": "Percentuale e numero di email aperte dai tuoi destinatari",
  "analytics_events_queued": "In coda",
  "analytics_events_queued_tooltip": "Percentuale di email in attesa di essere consegnate ai tuoi destinatari",
  "analytics_events_sent": "Consegnate",
  "analytics_events_spam": "Spam",
  "analytics_events_spam_tooltip": "Percentuale dei tuoi destinatari che hanno segnalato la mail come spam",
  "analytics_events_unsubscribes": "Disiscrizioni",
  "analytics_events_unsubscribes_tooltip": "Percentuale dei tuoi destinatari che si sono disiscritti",
  "analytics_file": "File caricato",
  "analytics_filterby_domain": "Dominio",
  "analytics_filterby_recipient": "Destinatario",
  "analytics_filterby_sender": "Mittente",
  "analytics_filterby_subject": "Oggetto",
  "analytics_numbers": "Numeri",
  "analytics_openclick": "Statistiche Open/Click",
  "analytics_overview": "Panoramica",
  "analytics_percentage": "Percentuale",
  "analytics_reason": "Motivo",
  "analytics_recipient": "Destinatario",
  "analytics_sender": "Mittente",
  "analytics_status": "Stato",
  "analytics_subject": "Oggetto",
  "analytics_temporary_error": "Errore temporaneo. Per favore, riprova più tardi.",
  "analytics_title": "Statistiche",
  "analytics_topforopens": "Top aperture",
  "analytics_total_emails": "Email totali",
  "analytics_total_processed": "Totale email processate",
  "analytics_upload_date": "Data",
  "and": "e",
  "annually": "Annuale",
  "authentication_expired": "Autenticazione scaduta, fai di nuovo login.",
  "bcc_verification_code_invalid": "CCN il codice di verifica non è valido.",
  "bcc_verified": "CCN verificato con successo",
  "billing_changepassword_description": "Cambia la tua password in questa sezione. Questa password viene utilizzata solo per accedere alla Dashboard.\n",
  "billing_changepassword_title": "Cambia password",
  "billing_contact_were_not_found": "Il cotatto per la fatturazione non è stato trovato.",
  "billing_contacts_address": "Indirizzo",
  "billing_contacts_address2": "Indirizzo 2",
  "billing_contacts_billing": "Email di fatturazione - Promemoria Fatture e pagamenti",
  "billing_contacts_button_add": "Aggiungi",
  "billing_contacts_button_edit": "Modifica",
  "billing_contacts_city": "Città",
  "billing_contacts_company": "Azienda",
  "billing_contacts_country": "Nazione",
  "billing_contacts_domain_email": "Servizi",
  "billing_contacts_editcontact": "Modifica contatto",
  "billing_contacts_email": "Indirizzo E-mail",
  "billing_contacts_empty": "Le comunicazioni e-mail verranno inviate all'indirizzo nel tuo account principale. Inserisci più indirizzi per inviare comunicazioni anche ad altri destinatari.",
  "billing_contacts_firstname": "Nome",
  "billing_contacts_general_email": "Generale",
  "billing_contacts_invoice_email": "Fatture",
  "billing_contacts_lastname": "Cognome",
  "billing_contacts_marketing": "Email di servizio - Avvisi di rinnovo, conferme di registrazione, ecc.",
  "billing_contacts_phone": "Numero di telefono",
  "billing_contacts_products": "Email di prodotto - Dettagli ordini, Email di benvenuto, etc.",
  "billing_contacts_products_email": "Prodotti",
  "billing_contacts_slide_description": "Le comunicazioni e-mail verranno inviate all'indirizzo nel tuo account principale. Inserisci più indirizzi per inviare comunicazioni anche ad altri destinatari.",
  "billing_contacts_slide_title": "Aggiungi un nuovo contatto",
  "billing_contacts_stateregion": "Stato/Regione",
  "billing_contacts_subscriptions": "Iscrizioni",
  "billing_contacts_support": "Email di supporto - Permetti a questo utente di ricevere le email dei ticket del tuo account",
  "billing_contacts_support_email": "Supporto",
  "billing_contacts_terms": "Ho letto e accetto l'<a href=\"https://serversmtp.com/it/norme-sulla-privacy-regolamento-ue-2016-79-gdpr/\" target=\"_blank\">informativa sulla privacy</a> e i <a href=\"https://serversmtp.com/it/termini-e-condizioni/\" target=\"_blank\">termini e condizioni</a> del servizio.",
  "billing_contacts_title": "Contatti",
  "billing_contacts_transactional": "Email generali - Comunicazioni generali e promemoria password",
  "billing_contacts_zip": "CAP",
  "billing_details_contact_above": "Invia solo al contatto di default.",
  "billing_emails_sentdate": "Data di invio",
  "billing_emails_subject": "Oggetto",
  "billing_invoice_date": "Data",
  "billing_invoice_duedate": "Data di scadenza",
  "billing_invoice_number": "Numero",
  "billing_invoice_status": "Stato",
  "billing_invoice_status_cancelled": "Annullato",
  "billing_invoice_status_paid": "Pagato",
  "billing_invoice_status_refunded": "Rimborsato",
  "billing_invoice_status_unpaid": "Non pagato",
  "billing_invoice_total": "Totale",
  "billing_product_payment_method_banktransfer": "Bonifico bancario",
  "billing_product_paymentmethod_avangate": "Carta di credito (Verizon former 2Checkout)",
  "billing_product_paymentmethod_stripe": "Carta di credito (Stripe)",
  "button_add_contact": "Aggiungi contatto",
  "button_add_filter": "Aggiungi filtro",
  "button_add_plan": "Aggiungi un piano",
  "button_add_sender": "Aggiungi mittente",
  "button_add_subaccount": "Aggiungi un sub account",
  "button_add_suppression": "Aggiungi suppression",
  "button_add_template": "Aggiungi Template",
  "button_addbcc": "Aggiungi CCN",
  "button_addfooter": "Aggiungi Footer",
  "button_advanced_search": "Ricerca avanzata",
  "button_apply": "Applica",
  "button_back": "Indietro",
  "button_basic_search": "Ricerca semplice",
  "button_buycredits": "Acquista crediti",
  "button_cancel": "Annulla",
  "button_close": "Chiudi",
  "button_contact_us": "Contattaci",
  "button_copy": "Copia",
  "button_create": "Crea",
  "button_createalert": "Crea un Alert",
  "button_delete": "Elimina",
  "button_delete_all": "Cancella tutti",
  "button_delete_filtered": "Cancella filtrati",
  "button_delete_selected": "Cancella selezionati ({n})",
  "button_edit": "Modifica",
  "button_export": "Esporta",
  "button_import": "Importa file",
  "button_limits": "Imposta limiti",
  "button_more": "Mostra dettagli",
  "button_next": "Avanti",
  "button_open_ticket": "Apri un ticket",
  "button_pay": "Paga ora",
  "button_refresh": "Aggiorna",
  "button_reload": "Ricarica",
  "button_request_cancellation": "Richiedi cancellazione",
  "button_reset": "Reimposta",
  "button_returnlist": "Ritorna alla lista",
  "button_save": "Salva",
  "button_search": "Cerca",
  "button_select_fromdevice": "Selezione i file dal tuo dispositivo",
  "button_submit_ticket": "Invia ticket",
  "button_unsubscribe": "Aggiungi link disiscrizione",
  "button_update": "Aggiorna",
  "button_update_template": "Aggiorna il template",
  "button_update_unsubscribe": "Aggiorna link disiscrizione",
  "button_updatealert": "Aggiorna Alert",
  "button_updatebcc": "Aggiorna CCN",
  "button_updatefooter": "Aggiorna Footer",
  "button_upgrade": "Upgrade",
  "button_upload": "Carica",
  "confirm_password_is_missing": "È obbligatorio confermare la password",
  "dashboard_clicked": "Click",
  "dashboard_delivered": "Consegnate",
  "dashboard_emails_sent": "email totali",
  "dashboard_emails_sent_out_of": "Email inviate da",
  "dashboard_gotoanalytics": "Vai alle statistiche",
  "dashboard_new_version": "È disponibile un aggiornamento!",
  "dashboard_new_version_cancel": "Ok",
  "dashboard_new_version_description": "Prima salva il tuo lavoro e ricarica la pagina, o clicca su \"Aggiorna ora\" per ottenere subito la nuova versione.",
  "dashboard_new_version_ok": "Aggiorna ora",
  "dashboard_plan_emails": "email",
  "dashboard_plan_label": "Piano",
  "dashboard_plan_label_interval": "Piano {interval}",
  "dashboard_plan_limit_unit_daily": "giorno",
  "dashboard_plan_limit_unit_monthly": "mese",
  "dashboard_plan_limit_unit_yearly": "anno",
  "dashboard_recent_email_activities": "Attività email recenti",
  "dashboard_try": "Stai usando una versione di prova gratuita. Per vedere la dashboard completa:",
  "datepicker_last_3_months": "Ultimi 3 mesi",
  "datepicker_last_30days": "Ultimi 30 giorni",
  "datepicker_last_month": "Ultimo mese",
  "datepicker_last_sevendays": "Ultimi 7 giorni",
  "datepicker_last_week": "Ultima settimana",
  "datepicker_last_year": "L’anno scorso",
  "datepicker_this_month": "Questo mese",
  "datepicker_this_year": "Quest’anno",
  "datepicker_today": "Oggi",
  "datepicker_yesterday": "Ieri",
  "delete_all_bounce": "Elimina tutti i bounce",
  "delete_all_manual": "Elimina tutti gli inserimenti manuali",
  "delete_all_spam": "Elimina tutte le segnalazioni di spam",
  "delete_all_unsubscribe": "Elimina tutte le disiscrizioni",
  "delete_fist_login_dont": "Non mostrarmi più questo messaggio.",
  "delete_fist_login_one": "<h3>Benvenuto nella dashboard avanzata turboSMTP.</h3><p>Visualizza statistiche in tempo reale sulle tue campagne email<br>e migliora i tuoi risultati con strumenti professionali.</p><h4>Segui le istruzioni per la configurazione il tuo pannello.</h4>",
  "delete_fist_login_three_a": "Per favore, inserisci il nome del server SMTP nel tuo client email:",
  "delete_fist_login_three_b": "<p><strong class=\"font-xxl\">pro.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_b_eu": "<p><strong class=\"font-xxl\">pro.eu.turbo-smtp.com</strong></p>",
  "delete_fist_login_three_c": "Non dimenticare di configurare i DNS sul cPanel del tuo dominio,<br>puoi trovare i parametri nell'area 'Impostazioni'.",
  "delete_fist_login_two_a": "<h3>Open tracking</h3><p>turboSMTP traccia il tasso di apertura delle tue email.</p>",
  "delete_fist_login_two_b": "<h3>Click tracking</h3><p> turboSMTP traccia il tasso di clic delle tue email</p>",
  "first_login_apikey_description": "<h3>Genera la tua API Key</h3><p>Crea la tua API key predefinita per iniziare a inviare email programmaticamente. Questa chiave avrà i permessi SEND_SMTP e SEND_API.</p>",
  "first_login_generate_apikey": "Genera API Key",
  "first_login_apikey_generated": "<h3>API Key generata con successo!</h3><p>La tua API key è stata creata. Salva queste credenziali in modo sicuro poiché il Consumer Secret non verrà mostrato di nuovo.</p>",
  "first_login_apikey_warning": "<strong>Importante:</strong> Salva ora queste credenziali. Il Consumer Secret non può essere recuperato di nuovo.",
  "first_login_close_dont_show": "Chiudi e non mostrare più",
  "consumer_key": "Consumer Key",
  "consumer_secret": "Consumer Secret",
  "copied_to_clipboard": "Copiato negli appunti",
  "copy_failed": "Copia fallita",
  "editor_quill_button_title": "Mostra sorgente HTML",
  "editor_quill_cancel_text": "Annulla",
  "editor_quill_msg": "Modifica il contenuto in formato HTML",
  "editor_quill_ok_text": "Conferma",
  "emails_month": "email/mese",
  "emailvalidator_add_file": "Aggiungi file",
  "emailvalidator_add_form_errors": "Errori del form",
  "emailvalidator_add_form_nofile_selected": "Nessun file selezionato",
  "emailvalidator_add_value": "Puoi aggiungere un valore tra",
  "emailvalidator_attention": "Attenzione!",
  "emailvalidator_available": "crediti gratuiti",
  "emailvalidator_balance_description": "Il tuo credito è di:",
  "emailvalidator_balance_title": "Il tuo credito",
  "emailvalidator_buy_extra_credit": "Acquista crediti",
  "emailvalidator_complete": "Completato",
  "emailvalidator_confirm_delete_label": "Conferma azione",
  "emailvalidator_confirm_delete_text": "Sei sicuro di voler eliminare questa lista?",
  "emailvalidator_contact_support": "<a href=\"https://serversmtp.com/it/submitticket.php\" target=\"_blank\">Contatta il supporto <i class=\"ml-2 pi pi-external-link\"></i></a>",
  "emailvalidator_cost_per_email": "Il costo per ogni email è",
  "emailvalidator_date": "Data di creazione:",
  "emailvalidator_day": "Giorno",
  "emailvalidator_details_empty": "Non risultano elementi",
  "emailvalidator_domain": "Dominio",
  "emailvalidator_domain_age": "Età dominio",
  "emailvalidator_email": "Email",
  "emailvalidator_email_addesses": "indirizzi email",
  "emailvalidator_empty": "Un file caricato può contenere solo un indirizzo email per riga. I formati permessi sono csv e txt. Seleziona un file da caricare.",
  "emailvalidator_entry_details": "Dettagli pulizia liste",
  "emailvalidator_slide_description": "Il file deve essere costituito da un'unica colonna contenente tutti gli indirizzi email che si desidera importare.",
  "emailvalidator_validate_freecredits_used": "Verranno utilizzati i seguenti crediti gratuiti:",
  "emailvalidator_error": "Errore",
  "emailvalidator_error_contact_support": "Si è verificato un errore: vi preghiamo di contattare il supporto.",
  "emailvalidator_expiring": "scadenza il",
  "emailvalidator_export": "Esporta",
  "emailvalidator_free_email": "Email gratuita",
  "emailvalidator_how_many": "Quante email vuoi validare?",
  "emailvalidator_list_contains": "La lista caricata contiene",
  "emailvalidator_list_not_removed": "Si è verificato un errore durante la cancellazione della lista.",
  "emailvalidator_list_removed": "La lista è stata rimossa con successo.",
  "emailvalidator_mx_record": "Record MX",
  "emailvalidator_please_enter_amout": "Per favore, seleziona la cifra che vuoi aggiungere al tuo portafoglio virtuale.",
  "emailvalidator_price_calculator": "Calcola il prezzo",
  "emailvalidator_price_email": "Prezzo per Email",
  "emailvalidator_process_now": "Elabora ora",
  "emailvalidator_refresh": "Aggiorna",
  "emailvalidator_slide_details_description": "I formati di file consentiti sono csv e txt.",
  "emailvalidator_slide_details_title": "Trascina e rilascia il tuo file qui.",
  "emailvalidator_slide_manually_description": "Copia e incolla più indirizzi email nell'area sottostante, separati da una riga finale.",
  "emailvalidator_slide_manually_title": "Aggiungi manualmente",
  "emailvalidator_slide_placeholder": "email1@yourdomain.com, email2@yourdomain.com",
  "emailvalidator_smpt_provider": "Provider SMTP",
  "emailvalidator_status": "Stato",
  "emailvalidator_status_abuse": "Abuso",
  "ip_not_associated_to_user_account": "L'IP non è stato associato al subaccount.",
  "emailvalidator_status_catch_all": "Catch-all",
  "emailvalidator_status_do_not_mail": "Non inviata",
  "emailvalidator_status_invalid": "Non valido",
  "emailvalidator_status_spamtrap": "Spam",
  "emailvalidator_status_unknown": "Sconosciuto",
  "emailvalidator_status_valid": "Valido",
  "emailvalidator_title": "Pulizia liste",
  "emailvalidator_total_cost": "Il costo totale è",
  "emailvalidator_upload_warning": "Il tuo saldo credito corrente è {current_balance}. Devi acquistare {needed_balance} di credito extra per convalidare questa lista...",
  "emailvalidator_validate_list": "Pulisci la lista",
  "emailvalidator_validate_now": "Inizia la pulizia",
  "emailvalidator_validated_lists": "Liste verificate",
  "emailvalidator_validation_date": "Data di convalida",
  "emailvalidator_value": "Valore",
  "emailvalidator_you_have": "Hai a disposizione",
  "empty_authorization_token": "Il token di autorizzazione è vuoto",
  "empty_request_body": "Il corpo della richiesta è vuoto",
  "error": "Errore",
  "file_too_large": "Il file è troppo grande per essere caricato.",
  "filter": "Filtri",
  "filter_by": "Filtrare per:",
  "filter_fuzzy": "Ricerca smart",
  "filter_fuzzy_description": "Abilita questa funzione per visualizzare elementi simili al termine di ricerca.",
  "filter_placeholder_analytics": "Cerca...",
  "filter_placeholder_suppressions": "Cerca...",
  "filters_show": "Mostra filtri",
  "filters_hide": "Nascondi filtri",
  "filter_suppressions_placeholder": "Cerca per destinatario, mittente, oggetto email o motivo di soppressione",
  "first_login_step": "Step {n}",
  "forgot_password_changed": "La tua password è stata modificata correttamente.",
  "forgot_password_click": "Clicca qui",
  "forgot_password_confirm": "Conferma la password",
  "forgot_password_done": "Fatto!",
  "forgot_password_donot_match": "Le password non coincidono.",
  "forgot_password_email_not_found": "Indirizzo email non trovato",
  "forgot_password_enter_email": "Il tuo indirizzo email di accesso",
  "forgot_password_error": "Si è verificato un errore durante la modifica della password.",
  "forgot_password_expired": "Il link per cambiare la password è scaduto.",
  "forgot_password_pick": "Scegli la password",
  "forgot_password_please_reset": "Imposta la password",
  "forgot_password_recovery_email_sent": "L'e-mail di recupero password è stata inviata.",
  "forgot_password_resend": "per inviare di nuovo l'email.",
  "forgot_password_reset": "Reimposta la password",
  "forgot_password_send_password_reset_link": "Invia link reset password",
  "forgot_password_sent_email_to_update_password": "Ti abbiamo appena inviato un'email con un link per aggiornare la tua password.",
  "forgot_password_set": "Imposta la nuova password",
  "forgot_password_should_have": "La password dovrebbe contenere",
  "forgot_password_suggestions": "<li>Almeno un carattere minuscolo</li> <li>Almeno un carattere maiuscolo</li><li>Almeno un numero</li><li>Minimo 10 caratteri</li>",
  "forgot_password_switch": "Torna al login",
  "forgot_password_switch_to_login": "Torna al login",
  "forgot_password_token_is_missing": "Manca il token della password dimenticata",
  "forgot_password_unable_to_send": "Non è stato possibile inviare un'email.",
  "forgot_password_username": "Username email",
  "forgot_password_we_will_send_you": "Ti invieremo un link per il recupero della password.",
  "free_account": "Piano gratuito",
  "friday": "Venerdì",
  "fuzzy_tooltip": "Abilita questa funzione per visualizzare elementi simili al termine di ricerca.",
  "goto_emailmarketing": "Vai a Email marketing",
  "goto_emailvalidator": "Vai a Pulizia liste",
  "header_menu_support": "https://serversmtp.com/it/supporto-clienti-multilingua-24-7/",
  "internal_server_error_try_again": "Errore interno del server. Per favore, riprova più tardi.",
  "invalid_authorization_key": "La chiave di autorizzazione non è valida.",
  "invalid_authorization_token": "Token di autorizzazione non valido",
  "invalid_limit_parameter_value_must_be_greater_than_or_equals_1": "Il valore del parametro limite non valido deve essere maggiore o uguale a 1",
  "invalid_page_parameter_value_must_be_greater_than_or_equals_1": "Il valore del parametro della pagina non valido deve essere maggiore o uguale a 1",
  "invalid_value_for_orderby_parameter": "Il parametro 'ordina per' non è valido.",
  "invalid_value_for_the_parameter_type": "Valore non valido per il tipo di parametro",
  "invoice_not_found": "Fattura non trovata",
  "jwt_error_full_details": "Dettagli tecnici completi",
  "jwt_error_status": "Stato HTTP",
  "jwt_error_url": "URL",
  "jwt_url_not_exists": "La seguente URL non esiste",
  "l_allrights": "Tutti i diritti sono riservati",
  "l_antispam_policy": "Politica Anti-spam",
  "l_copyright": "© turboSMTP 2010 - ",
  "l_dont_have_account": "Non hai ancora un account?",
  "l_email_address": "Indirizzo email",
  "l_forgot_password": "Hai dimenticato la password?",
  "l_login": "Login",
  "l_password": "Password",
  "l_privacy_policy": "Politica sulla privacy",
  "l_remember_me": "Resta connesso.",
  "l_sign_up_here": "Iscriviti qui",
  "l_tagline": "TurboSMTP - SMTP professionale.",
  "l_username_email": "Nome utente - email",
  "l_welcome_back": "Bentornato",
  "language_changed_label": "La lingua è cambiata",
  "language_changed_message": "Per applicare la modifica della lingua, ricarica la pagina",
  "language_changed_reload": "Ricarica",
  "m_accountinfo": "Informazioni account",
  "m_addons": "Addon",
  "m_analytics": "Statistiche",
  "m_billing": "Fatture pro forma",
  "m_daily": "Giornaliero",
  "m_dashboard": "Dashboard",
  "m_emailsentout": "email inviate",
  "m_emailvalidator": "Pulizia liste",
  "m_livechat": "Chat online",
  "m_messages": "Messaggi ricevuti",
  "m_monthly": "Mensile",
  "m_myaccount": "Il mio account",
  "m_mydetails": "Il mio account",
  "m_noplans": "Nessun piano",
  "m_of": "di",
  "m_products": "I miei prodotti",
  "m_savechanges": "Salva modifiche",
  "m_settings": "Impostazioni",
  "m_subaccounts": "Sub Account",
  "m_suppressions": "Blacklist",
  "m_tickets": "I miei ticket",
  "m_validuntil": "Valido fino a",
  "m_yearly": "Annuale",
  "missing_authorization_key": "Manca la chiave di autorizzazione.",
  "missing_or_invalid_value_provided_for_whiteLabeled_variable": "Valore mancante o non valido fornito per la variabile WhiteLabeled",
  "missing_required_parameter": "Manca il parametro richiesto",
  "missing_required_parameter_email": "Manca l'email del parametro richiesto",
  "missing_required_parameter_from": "Manca il parametro 'Da'",
  "missing_required_parameter_to": "Manca il parametro 'to'",
  "missing_required_parameter_tz": "Manca il parametro 'tz'",
  "modal_confirmation": "Conferma",
  "monday": "Lunedì",
  "monthly": "Mensile",
  "my_account_title": "Il mio account",
  "myaccount_account_details": "Il mio account",
  "myaccount_billing": "Fatture pro forma",
  "myaccount_billing_cancellation_contact_support": "Contatta il supporto",
  "myaccount_billing_cancellation_endofcycle_note": "Il tuo abbonamento rimarrà attivo fino alla fine del periodo di fatturazione in corso, dopodiché non verrà rinnovato.",
  "myaccount_billing_cancellation_proceed": "Procedi con la cancellazione",
  "myaccount_billing_cancellation_reason": "Motivo della cancellazione",
  "myaccount_billing_cancellation_select_reason": "Seleziona un motivo",
  "myaccount_billing_cancellation_support_text": "Prima di procedere, il nostro supporto potrebbe aiutarti a risolvere il problema senza dover cancellare l'abbonamento. Vuoi contattarci prima?",
  "myaccount_billing_contacts": "Gestisci i contatti",
  "myaccount_billing_contacts_description": "Le comunicazioni e-mail verranno inviate all'indirizzo nel tuo account principale. Inserisci più indirizzi per inviare comunicazioni anche ad altri destinatari.",
  "myaccount_billing_description": "In questa sezione trovi le tue fatture pro forma che vengono emesse prima delle fatture fiscali vere e proprie.<br>Le fatture fiscali ti verranno inviate via email.",
  "myaccount_billing_details": "Account e informazioni di fatturazione",
  "myaccount_billing_details_address": "Indirizzo",
  "myaccount_billing_details_address2": "Indirizzo 2",
  "myaccount_billing_details_billing_company_name": "Azienda",
  "myaccount_billing_details_billing_contact": "Invia le fatture pro forma a un contatto diverso da quello dell'account",
  "myaccount_billing_details_billing_vat": "P.IVA / C.F. ",
  "myaccount_billing_details_billing_website": "Indirizzo internet",
  "myaccount_billing_details_city": "Città",
  "myaccount_billing_details_country": "Nazione",
  "myaccount_billing_details_description": "Cambia i dettagli del tuo account e il tuo indirizzo di fatturazione",
  "myaccount_billing_details_details": "Dettagli per la fatturazione",
  "myaccount_billing_details_email": "Indirizzo email",
  "myaccount_billing_details_fistname": "Nome",
  "myaccount_billing_details_lastname": "Cognome",
  "myaccount_billing_details_marketing": "Desidero ricevere offerte e suggerimenti dedicati da turboSMTP",
  "myaccount_billing_details_phone_number": "Numero di telefono",
  "myaccount_billing_details_policy": "Ho letto e accetto la <a href=\"https://serversmtp.com/it/norme-sulla-privacy-regolamento-ue-2016-79-gdpr/\" target=\"_blank\">informativa sulla privacy</a> e i <a href=\"https://serversmtp.com/it/termini-e-condizioni/\" target=\"_blank\">termini e condizioni</a> del servizio",
  "myaccount_billing_details_state": "Stato/Regione",
  "myaccount_billing_details_zip": "CAP",
  "myaccount_billing_slides_description": "In questa sezione troverai le 'Fatture pro forma' relative al tuo account.",
  "myaccount_billing_slides_nodata": "Non sono state trovate fatture pro forma.",
  "myaccount_billingcontacts_added": "Contatto per la fatturazione aggiunto con successo",
  "myaccount_billingcontacts_deleted": "Contatto per la fatturazione eliminato con successo",
  "myaccount_billingcontacts_edited": "Contatto per la fatturazione modificato correttamente",
  "myaccount_billingdetails_updated": "I dettagli di fatturazione sono stati aggiornati",
  "myaccount_change_password": "Cambia la password",
  "myaccount_confirm_delete_selectedcontact_label": "Conferma azione",
  "myaccount_confirm_delete_selectedcontact_text": "Vuoi davvero eliminare questo contatto?",
  "myaccount_confirm_password": "Conferma password",
  "myaccount_current_password": "Password attuale",
  "myaccount_delimiter_change": "Modifica il delimitatore nei file CSV esportati",
  "myaccount_delimiter_select": "Seleziona il delimitatore",
  "myaccount_language": "Lingua intefaccia",
  "myaccount_language_change": "Modifica la lingua",
  "myaccount_language_description": "TurboSMTP è disponibile nelle seguenti lingue: Francese, Inglese, Italiano, Portoghese, Russo, Spagnolo e Tedesco (Arabo e Ebraico stanno arrivando in versione beta)",
  "myaccount_language_select": "Seleziona la lingua",
  "myaccount_localization": "Localizzazione",
  "myaccount_localization_description": "Modifica la lingua dell'interfaccia o il delimitatore dei file CSV esportati.",
  "myaccount_messages": "Messaggi ricevuti",
  "myaccount_messages_nomessages": "Non sono stati trovati messaggi.",
  "myaccount_messages_nomessages_description": "In questa sezione troverai i messaggi che il nostro sistema ha inviato al tuo account.",
  "myaccount_new_password": "Nuova password",
  "myaccount_password_changed": "La password è stata cambiata con successo",
  "myaccount_password_choose": "Scegli la tua nuova password",
  "myaccount_password_notmatch": "Le password non coincidono.",
  "myaccount_password_suggestions": "La password deve contenere almeno 10 caratteri e una minuscola e maiuscola e una cifra da 0 a 9",
  "myaccount_2fa_title": "Autenticazione a due fattori",
  "myaccount_2fa_description": "Migliora la sicurezza del tuo account abilitando l'autenticazione a due fattori (2FA). Questo aggiunge un ulteriore livello di protezione al tuo account.",
  "myaccount_2fa_card_description": "Abilita l'autenticazione a due fattori per proteggere il tuo account.",
  "myaccount_2fa_select_method": "Seleziona metodo di autenticazione",
  "myaccount_2fa_method": "Metodo di autenticazione",
  "myaccount_2fa_method_placeholder": "Scegli un metodo di autenticazione",
  "myaccount_2fa_otp_description": "Usa un'app di autenticazione (come Google Authenticator o Authy) per generare codici temporali.",
  "myaccount_2fa_email_description": "Ricevi codici di verifica via email.",
  "myaccount_2fa_sms_description": "Ricevi codici di verifica via SMS.",
  "myaccount_2fa_none_description": "Disabilita l'autenticazione a due fattori per il tuo account.",
  "myaccount_2fa_scan_qr": "Scansiona codice QR",
  "myaccount_2fa_scan_qr_description": "Scansiona questo codice QR con la tua app di autenticazione per configurare l'autenticazione a due fattori.",
  "myaccount_2fa_manual_entry": "Oppure inserisci questo codice manualmente:",
  "myaccount_2fa_copy_secret": "Copia negli appunti",
  "myaccount_2fa_secret_copied": "Chiave segreta copiata negli appunti",
  "myaccount_2fa_verify_code": "Verifica codice",
  "myaccount_2fa_enter_code": "Inserisci codice di verifica",
  "myaccount_2fa_code_placeholder": "000000",
  "myaccount_2fa_verify_code_description": "Inserisci il codice a 6 cifre dalla tua app di autenticazione per completare la configurazione.",
  "myaccount_2fa_method_updated": "Metodo di autenticazione a due fattori aggiornato con successo",
  "myaccount_2fa_otp_enabled": "Autenticazione a due fattori abilitata con successo",
  "myaccount_2fa_current_status": "Stato attuale",
  "myaccount_2fa_status": "Stato autenticazione a due fattori",
  "myaccount_2fa_status_disabled": "Disabilitato",
  "myaccount_2fa_error_no_keycloak_id": "Impossibile configurare 2FA: ID utente non trovato",
  "myaccount_2fa_error_invalid_code": "Codice di verifica non valido. Riprova.",
  "myaccount_2fa_error_generic": "Si è verificato un errore durante la configurazione dell'autenticazione a due fattori",
  "myaccount_2fa_enabled": "Abilitata",
  "myaccount_2fa_disabled_label": "Disabilitata",
  "myaccount_2fa_disabled": "Autenticazione a due fattori disabilitata con successo",
  "myaccount_product_delete_label": "Conferma azione",
  "myaccount_product_delete_text": "Sei sicuro di voler cancellare questo prodotto?",
  "myaccount_product_deleted": "La richiesta di cancellazione è stata inoltrata con successo.",
  "myaccount_products": "I miei prodotti",
  "myaccount_products_billingcycle": "Tipo fatturazione",
  "myaccount_products_cycle_annually": "Annuale",
  "myaccount_products_cycle_biennally": "Biennale",
  "myaccount_products_cycle_free_account": "Piano gratuito",
  "myaccount_products_cycle_month": "Mensile",
  "myaccount_products_cycle_monthly": "Mensile",
  "myaccount_products_cycle_one_time": "Una tantum",
  "myaccount_products_cycle_onetime": "Una tantum",
  "myaccount_products_cycle_quarterly": "Trimestrale",
  "myaccount_products_cycle_semi-annually": "Semi-annuale",
  "myaccount_products_cycle_triennially": "Trieennale",
  "myaccount_products_cycle_year": "Annuale",
  "myaccount_products_cycle_yearly": "Annuale",
  "myaccount_products_fistpayment": "Importo primo pagamento",
  "myaccount_products_nextduedate": "Data di scadenza",
  "myaccount_products_noproduct": "Nessun prodotto associato all'account",
  "myaccount_products_noproduct_description": "In questa sezione troverai i prodotti e i servizi associati all'account.",
  "myaccount_products_payment": "Metodo di pagamento",
  "myaccount_products_price": "Prezzo",
  "myaccount_products_productservice": "Prodotto/Servizio",
  "myaccount_products_recurringamount": "Importo ricorrente",
  "myaccount_products_registration": "Data registrazione",
  "myaccount_products_slide_productservice_description": "Gestisci i tuoi prodotti da quest'area.",
  "myaccount_products_status": "Stato",
  "plans_addon_options_title": "Piani aggiuntivi",
  "plans_available_recurring_options_title": "Piani Disponibili",
  "plans_billing_cycle": "Ciclo di fatturazione",
  "plans_current_plans_title": "I tuoi piani attuali",
  "plans_cycle_month": "Mensile",
  "plans_cycle_monthly": "Mensile",
  "plans_cycle_onetime": "Una tantum",
  "plans_cycle_year": "Annuale",
  "plans_cycle_yearly": "Annuale",
  "plans_downgrade_options_title": "Opzioni di downgrade",
  "plans_feature_dedicated_ip": "IP dedicato",
  "plans_feature_email_credits": "Crediti email",
  "plans_feature_smtp_limit": "Limite SMTP",
  "plans_features": "Caratteristiche",
  "plans_invoice_created": "La fattura è stata creata con successo.",
  "plans_invoice_error": "Impossibile creare la fattura. Riprova.",
  "plans_load_error": "Impossibile caricare le opzioni del piano. Riprova.",
  "plans_onetime_options_title": "Piani una tantum",
  "plans_plan_name": "Nome del piano",
  "plans_plan_type": "Tipo di piano",
  "plans_select_plan": "Seleziona piano",
  "plans_type_addon": "Aggiuntivo",
  "plans_type_onetime": "Una tantum",
  "plans_type_recurring": "Ricorrente",
  "plans_upgrade_options_title": "Opzioni di upgrade",
  "myaccount_sentdate": "Data di invio:",
  "new_dashboard_error": "Si è verificato un errore durante la verifica del token:",
  "new_dashboard_if_you_think": "Se pensi di visualizzare questo messaggio per errore, <a href=\"https://serversmtp.com/contact-us/\" target=\"_blank\">contatta il supporto</a>.",
  "new_dashboard_not_allowed": "Contatta il nostro <a href='https://serversmtp.com/it/contatti/' target='_blank'>team di supporto</a> per iniziare a usare la versione beta della dashboard.",
  "new_dashboard_token_valid": "Il token è valido.",
  "new_dashboard_token_wrong": "Token non risulta corretto.",
  "new_dashboard_validating": "Stiamo verificando il token...",
  "no": "No",
  "no_parameters_was_provided_for_update": "Nessun parametro è stato fornito per l'aggiornamento",
  "no_suppression_data_were_provided": "Non sono stati forniti dati per la blacklist",
  "one_time": "Una tantum",
  "optional": "Opzionale",
  "or": "oppure",
  "password_is_invalid": "Nessun account corrispondeva alla password fornita",
  "password_is_missing": "Password mancante",
  "password_length_should_not_be_less_than_10_characters": "La password deve contenere almeno 10 caratteri",
  "password_should_contain_at_least_one_uppercase_character": "La password deve contenere almeno 1 carattere maiuscolo",
  "password_should_contain_at_least_one_lowercase_character": "La password deve contenere almeno 1 carattere minuscolo",
  "password_should_contain_at_least_one_digit": "La password deve contenere almeno 1 cifra",
  "password_should_equals_to_confirm_password": "Password e Conferma password devono corrispondere",
  "plan": "piano",
  "plan_daily": "Piano giornaliero",
  "plan_desc": "{order}. {smtp_limit_interval} {planT} ({smtp_limit} / {limit_unit})",
  "plan_desc_small": "{smtp_limit} email / {limit_unit}",
  "plan_monthly": "Piano mensile",
  "plan_short_daily": "giorno",
  "plan_short_monthly": "mese",
  "plan_short_yearly": "anno",
  "plan_yearly": "Piano annuale",
  "primeng": {
    "accept": "Si",
    "addRule": "Aggiungi regola",
    "after": "Dopo",
    "apply": "Applica",
    "before": "Prima",
    "cancel": "Annulla",
    "choose": "Scegli",
    "clear": "Cancella",
    "contains": "Contiene",
    "dateAfter": "La data è successiva",
    "dateBefore": "La data è precedente",
    "dateFormat": "gg/mm/aa",
    "dateIs": "La data è",
    "dateIsNot": "La data non è",
    "dayNames": [
      "Domenica",
      "Lunedì",
      "Martedì",
      "Mercoledì",
      "Giovedì",
      "Venerdì",
      "Sabato"
    ],
    "dayNamesMin": [
      "Do",
      "Lu",
      "Ma",
      "Me",
      "Gi",
      "Ve",
      "Sa"
    ],
    "dayNamesShort": [
      "Dom",
      "Lun",
      "Mar",
      "Mer",
      "Gio",
      "Ven",
      "Sab"
    ],
    "emptyFilterMessage": "Nessun risultato trovato",
    "emptyMessage": "Nessun risultato trovato",
    "endsWith": "Finisce con",
    "equals": "uguale",
    "firstDayOfWeek": 1,
    "gt": "Maggiore di",
    "gte": "Maggiore o uguale a",
    "is": "È",
    "isNot": "Non è",
    "lt": "Meno di",
    "lte": "Inferiore o uguale a",
    "max_limit_reached": "Hai raggiunto il numero massimo di subaccount attivabili con il tuo piano attuale.",
    "matchAll": "Abbina tutto",
    "matchAny": "Abbina qualsiasi",
    "medium": "Media",
    "monthNames": [
      "Gennaio",
      "Febbraio",
      "Marzo",
      "April",
      "Maggio",
      "Giugno",
      "Luglio",
      "Agosto",
      "Settembre",
      "Ottobre",
      "Novembre",
      "Dicembre"
    ],
    "monthNamesShort": [
      "Gen",
      "Feb",
      "Mar",
      "Apr",
      "Mag",
      "Giu",
      "Lug",
      "Ago",
      "Set",
      "Ott",
      "Nov",
      "Dic"
    ],
    "noFilter": "Nessun filtro",
    "notContains": "Non contiene",
    "notEquals": "Non uguale",
    "passwordPrompt": "Inserisci la password",
    "reject": "No",
    "removeRule": "Rimuovi regola",
    "startsWith": "Inizia con",
    "strong": "Forte",
    "today": "Oggi",
    "upload": "Carica",
    "weak": "Debole",
    "weekHeader": "Sett."
  },
  "return_toaddons": "Torna ad Addon",
  "saturday": "Sabato",
  "server_error_please_try_again": "Si è verificato un errore, ti preghiamo di riprovare.",
  "server_error_while_performing_update": "Si è verificato un errore del server durante l'esecuzione dell'aggiornamento",
  "server_problem_gateway_timeout": "Server Gateway timeout, riprova.",
  "server_problem_please_retry": "Problema con il server, riprova.",
  "server_problem_unknown_error": "Problema con il server sconosciuto, riprova.",
  "settings_activities_description": "Ricevi i report sulle attività del tuo account direttamente nella tua casella di posta. I report possono essere giornalieri, settimanali e/o mensili e coprono tutte le attività del tuo account.",
  "settings_activities_integrate": "Abilita l'invio di analisi per ricevere report per tutte le attività del tuo account.",
  "settings_activities_slide_dailyreport": "Report giornaliero",
  "settings_activities_slide_day": "Giorno del mese",
  "settings_activities_slide_dayoftheweek": "Giorno della settimana",
  "settings_activities_slide_description": "Puoi ricevere report giornalieri, settimanali e mensili per tutte le attività del tuo account. Il tuo report verrà inviato al tuo indirizzo email di registrazione.",
  "settings_activities_slide_monthlyreport": "Rapporto mensile",
  "settings_activities_slide_time": "Orario",
  "settings_activities_slide_title": "Report delle attività",
  "settings_activities_slide_weeklyreport": "Rapporto settimanale",
  "settings_activities_title": "Report delle attività",
  "settings_alert_usage_limit": "Limite uso",
  "settings_alerts_description": "Ricevi una notifica via email quando raggiungi delle soglie specifiche di utilizzo dei tuoi piani di invio.",
  "settings_alerts_slide_add": "Aggiungi un alert",
  "settings_alerts_slide_description": "Per evitare di esaurire i crediti mail nel bel mezzo di un invio, imposta un avviso da inviare al tuo indirizzo email quando raggiungi una determinata percentuale dei tuoi crediti. Ti consigliamo di attivare l'avviso all'80% del tuo credito disponibile.",
  "settings_alerts_slide_empty_description": "Ricevi un alert che verrà inviato al tuo indirizzo di porta quando raggiungi una certa percentuale dei tuoi crediti email.",
  "settings_alerts_slide_empty_title": "Aggiungi un avviso",
  "settings_alerts_slide_frequency": "Frequenza",
  "settings_alerts_slide_percentage": "Percentuale",
  "settings_alerts_slide_placeholder": "Esempio: name@addres.com",
  "settings_alerts_slide_sendto": "Invia a",
  "settings_alerts_slide_title": "Avvisi",
  "settings_alerts_slide_type": "Tipo avviso",
  "settings_alerts_title": "Avvisi",
  "settings_api_description": "Invia le tue email direttamente dal tuo sito o dalla tua APP con le API di turboSMTP.",
  "settings_api_title": "Documentazione API",
  "settings_bccs_description": "Consenti ad alcuni indirizzi email verificati di ricevere una copia di ogni messaggio inviato.",
  "settings_bccs_enable": "Abilita per autorizzare un account di posta elettronica a ricevere una copia di tutte le email inviate",
  "settings_bccs_slide_add": "Aggiungi un indirizzo Ccn",
  "settings_bccs_slide_description": "Un indirizzo email aggiunto alla lista Ccn riceverà una copia di ogni email inviata, senza che i destinatari vedano i dettagli degli altri destinatari.",
  "settings_bccs_slide_email": "Email",
  "settings_bccs_slide_empty": "Imposta e autorizza un account email che riceverà una copia di ogni email inviata.",
  "settings_bccs_slide_empty_title": "Aggiungi un indirizzo Ccn",
  "settings_bccs_slide_name": "Nome",
  "settings_bccs_slide_not_verified": "Non verificato",
  "settings_bccs_slide_status": "Stato",
  "settings_bccs_slide_title": "Ccn (Copia conoscenza nascosta)",
  "settings_bccs_slide_verified": "Verificato",
  "settings_bccs_title": "Ccn (Copia conoscenza nascosta)",
  "settings_bounces_description": "Attiva la Gestione bounce per far arrivare a noi le notifiche relative alle email non consegnate (bounce). Per ricevere tu stesso le notifiche di bounce, disabilita questa impostazione.",
  "settings_bounces_slide_description": "settings_bounces_slide_description",
  "settings_bounces_slide_suppressbounce": "settings_bounces_slide_suppressbounce",
  "settings_bounces_slide_title": "Notifiche dei bounce",
  "settings_bounces_title": "Gestione bounce",
  "settings_click_tracking": "Click Tracking",
  "settings_click_tracking_description": "Attiva il Click Tracking per registrare tutti i click fatti sui link delle tue email.",
  "settings_dns_bar_description": "Dovresti impostare i record SPF e DKIM su tutti i domini degli indirizzi e-mail del mittente.",
  "settings_dns_bar_dkim_description": "Un record DKIM può essere aggiunto come record TXT inserendo la stringa seguente:",
  "settings_dns_bar_dkim_domain": "Dominio",
  "settings_dns_bar_dkim_title": "Record DKIM",
  "settings_dns_bar_dkim_value": "Valore",
  "settings_dns_bar_domainaut": "Autenticazione Dominio",
  "settings_dns_bar_domainaut_description": "Autorizza TurboSMTP a inviare le mail per te",
  "settings_dns_bar_domainaut_is": "L'autenticazione del dominio è in modalità:",
  "settings_dns_bar_spf_description": "Aggiungi il seguente record TXT al dominio dell’indirizzo (example.com), seguendo uno dei due casi:",
  "settings_dns_bar_spf_description_a": "<strong>Nel caso in cui nelle impostazioni DNS del tuo dominio sia già presente un record DNS</strong>, dovrai modificarlo. Ti basta inserire ",
  "settings_dns_bar_spf_description_b": " direttamente dopo ",
  "settings_dns_bar_spf_description_c": "Ricorda di lasciare uno spazio prima e dopo questa aggiunta per mantenere la corretta sintassi.",
  "settings_dns_bar_spf_description_d": "<strong>In assenza di un SPF</strong>, crea un nuovo record TXT e inserisci il valore riportato di seguito (non è necessario specificare un nome dominio, a meno che non sia esplicitamente richiesto):",
  "settings_dns_bar_spf_title": "Record SPF",
  "settings_dns_bar_title": "Impostazioni DNS",
  "settings_dns_description": "Per firmare le email con DKIM e SPF, e migliorare quindi la deliverability, usa i nostri record DNS.",
  "settings_dns_title": "Impostazioni DNS",
  "settings_email_body_tip": "Specifica un tag <% body %> all'interno del messaggio.",
  "settings_email_elements": "Elementi dell'email",
  "settings_email_footers_added": "Footeraggiunto con successo",
  "settings_email_footers_confirm_delete_label": "Conferma azione",
  "settings_email_footers_confirm_delete_text": "Vuoi davvero eliminare questo Footer?",
  "settings_email_footers_default": "Impostazioni Footer aggiornate con successo",
  "settings_email_footers_removed": "Footer rimosso con successo",
  "settings_email_footers_updated": "Footer aggiornato con successo",
  "settings_email_name_tip": "Specifica un nome per il valore",
  "settings_email_templates_added": "Template aggiunto con successo",
  "settings_email_templates_confirm_delete_label": "Conferma azione",
  "settings_email_templates_confirm_delete_text": "Vuoi davvero eliminare questo template?",
  "settings_email_templates_default": "Impostazioni modelli aggiornate con successo",
  "settings_email_templates_removed": "Template rimosso con successo",
  "settings_email_templates_updated": "Template aggiornato con successo",
  "settings_email_unsub_added": "Link di Unsubscribe aggiunto con successo",
  "settings_email_unsub_confirm_delete_label": "Conferma azione",
  "settings_email_unsub_confirm_delete_text": "Vuoi davvero eliminare questo link di Unsubscribe?",
  "settings_email_unsub_removed": "Il link di Unsubscribe è stato rimosso con successo",
  "settings_email_unsub_updated": "Link di Unsubscribe aggiornato con successo",
  "settings_footers_description": "Aggiungi un footer alle tue email.",
  "settings_footers_enable": "Abilita questa funzione per aggiungere un piè di pagina alle tue email",
  "settings_footers_slide_add": "Aggiungi Footer",
  "settings_footers_slide_convert": "Converti in testo",
  "settings_footers_slide_default": "Predefinito",
  "settings_footers_slide_description": "Clicca su 'Aggiungi Footer' o modifica un footer esistente, compilando i campi con il nome del footer e utilizzando HTML o testo semplice.",
  "settings_footers_slide_empty_description": "Clicca su 'Aggiungi Footer' o modifica un footer esistente, compilando i campi con il nome del footer e utilizzando HTML o testo semplice..",
  "settings_footers_slide_empty_title": "Non sono stati aggiunti Footer",
  "settings_footers_slide_htmltext": "Testo HTML",
  "settings_footers_slide_name": "Nome",
  "settings_footers_slide_plaintext": "Testo normale",
  "settings_footers_slide_title": "Footer",
  "settings_footers_title": "Footer",
  "settings_ga_bar_description": "Completa i seguenti campi, includendo il nome e la fonte dei dati della tua campagna, per attivare la tua integrazione Google Analytics.",
  "settings_ga_bar_title": "Google Analytics",
  "settings_ga_content": "Campaign content",
  "settings_ga_content_mandatory": "Il campo Campaign content è obbligatorio",
  "settings_ga_integrate": "Integra Google Analytics per tracciare il tuo tasso di conversione e altri dati.",
  "settings_ga_medium": "Campaign medium",
  "settings_ga_medium_mandatory": "Il campo Campaign medium  è obbligatorio",
  "settings_ga_name": "Campaign name",
  "settings_ga_name_mandatory": "Il campo Campaign name è obbligatorio",
  "settings_ga_parameters": "Parametri",
  "settings_ga_parameters_description": "Completa i seguenti campi, includendo il nome e la fonte dei dati della tua campagna, per attivare la tua integrazione Google Analytics.",
  "settings_ga_source": "Campaign source",
  "settings_ga_source_mandatory": "Il campo Campaign source è obbligatorio",
  "settings_ga_term": "Campaign term",
  "settings_ga_term_mandatory": "Il campo Campaign term è obbligatorio",
  "settings_google_analytics_description": "Aggiungi i parametri di Google Analytics per verificare i tuoi tassi di conversione e valutare l'efficacia delle tue campagne.",
  "settings_google_analytics_title": "Google Analytics",
  "settings_integrations": "Integrazioni",
  "settings_integrations_authentication_disabled": "L'autenticazione del dominio è ora in modalità: Disabilitato",
  "settings_integrations_authentication_enabled": "L'autenticazione del dominio è ora in modalità: Abilitato",
  "settings_integrations_dkim_updated": "Impostazioni DKIM aggiornate con successo",
  "settings_notification_alert_confirm_delete_label": "Conferma azione",
  "settings_notification_alert_confirm_delete_text": "Vuoi davvero eliminare questo avviso?",
  "settings_notification_bcc_confirm_delete_label": "Conferma azione",
  "settings_notification_bcc_confirm_delete_success": "Ccn {email} eliminata con successo.",
  "settings_notification_bcc_confirm_delete_text": "Vuoi davvero eliminare questo contatto CCn: {email} ?",
  "settings_notification_smtp_auth": "Autenticazione SMTP",
  "settings_notifications": "Notifiche",
  "settings_notifications_alert_added": "L'avviso è stato creato con successo.",
  "settings_notifications_alert_deleted": "L'avviso è stato cancellato  con successo.",
  "settings_notifications_alert_updated": "L'avviso è stato aggiornato  con successo.",
  "settings_notifications_bcc_emailbox": "Ti abbiamo inviato un messaggio di verifica all'indirizzo: <{email}>. Per favore controlla la tua casella di posta elettronica.",
  "settings_notifications_bcc_update_success": "CNn {email} è stata aggiornata con successo.",
  "settings_notifications_smtp_auth_enabled": "Abilitato",
  "settings_notifications_smtp_host": "pro.turbo-smtp.com",
  "settings_notifications_smtp_host_eu": "pro.eu.turbo-smtp.com",
  "settings_notifications_smtp_passvalue": "*********<br>(la password che utilizzi per entrare in questa dashboard)",
  "settings_notifications_smtp_password": "Password SMTP",
  "settings_notifications_smtp_ports": "Porte SMTP",
  "settings_notifications_smtp_server": "Server SMTP",
  "settings_notifications_smtp_username": "Username SMTP ",
  "settings_open_tracking": "Open Tracking",
  "settings_open_tracking_description": "Abilitando Open Tracking, creerai una 'registrazione' dei tuoi messaggi aperti, che ti permetterà di tracciare al meglio i risultati della tua campagna.",
  "settings_senders_description": "Aggiungi i tuoi mittenti qui",
  "settings_senders_domains": "Mittenti e domini",
  "settings_senders_title": "Mittenti autenticati",
  "settings_setting_google_changed": "Le impostazioni di Google analytics sono cambiate",
  "settings_setting_webhooks_changed": "Le impostazioni dei webhooks analytics sono cambiate",
  "settings_setting_activity_reports_changed": "Le impostazioni dei report delle attività sono cambiate",
  "settings_setting_changed": "Impostazione modificata {service}",
  "settings_setting_disabled": "Impostazione disabilitata {service}",
  "settings_setting_enabled": "Impostazione abilitata {service}",
  "settings_setting_notdisabled": "Impossibile disabilitare l'impostazione {service}.",
  "settings_setting_notenabled": "Impossibile abilitare l'impostazione {service}.",
  "settings_setting_webhook_notenabled": "I Web-hook di notifica eventi sono disponibili solo sui piani ricorrenti PRO.",
  "settings_setting_bccs_disabled": "Ccn (Copia conoscenza nascosta) è ora disabilitata",
  "settings_setting_bccs_enabled": "Ccn (Copia conoscenza nascosta) è ora abilitata",
  "settings_setting_post_smtp_bounce_disabled": "Gestione Bounce è ora disabilitata",
  "settings_setting_post_smtp_bounce_enabled": "Bounce management è ora abilitata",
  "settings_setting_periodicreport_disabled": "I report delle attività sono ora disabilitati",
  "settings_setting_periodicreport_enabled": "I report delle attività sono ora abilitati",
  "settings_setting_webhook_disabled": "I webhooks sono ora disabilitati",
  "settings_setting_webhook_enabled": "I webhooks sono ora abilitati",
  "settings_setting_unsubscribelinks_disabled": "I link di unsubscribe sono ora disabilitati",
  "settings_setting_unsubscribelinks_enabled": "I link di unsubscribe sono ora abilitati",
  "settings_setting_footers_disabled": "Il footer è ora disabilitato",
  "settings_setting_footers_enabled": "Il footer è ora abilitato",
  "settings_setting_templates_disabled": "Il template è ora disabilitato",
  "settings_setting_templates_enabled": "Il template è ora abilitato",
  "settings_setting_openingtracking_disabled": "L'open tracking ora disabilitato",
  "settings_setting_openingtracking_enabled": "L'open tracking ora abilitato",
  "settings_setting_clicktracking_disabled": "Il click tracking ora disabilitato",
  "settings_setting_clicktracking_enabled": "Il click tracking ora abilitato",
  "settings_setting_google_disabled": "Google analytics è ora disabilitato",
  "settings_setting_google_enabled": "Google analytics è ora abilitato",
  "settings_setting_link_branding_disabled": "I domini di tracking personalizzati sono ora disabilitati",
  "settings_setting_link_branding_enabled": "I domini di tracking personalizzati sono ora abilitati",
  "settings_smtp_description": "Configura l'SMTP sul tuo client di posta o su altre app email con questi parametri. Premi il pulsante “Mostra dettagli” per visualizzarli.",
  "settings_smtp_slide_description": "Il modo più semplice per inviare le tue email. Basta inserire i parametri per avviare la configurazione.",
  "settings_smtp_slide_description_api": "Il nome utente e la password di autenticazione SMTP sono una coppia di chiavi API: utilizzare il Consumer Key come nome utente SMTP e il Consumer Secret come password SMTP. Trattali come credenziali da mantenere segrete e da sostituire se necessario.",
  "settings_smtp_slide_parameter": "Parametro",
  "settings_smtp_slide_title": "Connessione via SMTP",
  "settings_smtp_slide_value": "Valore",
  "settings_smtp_title": "Connessione via SMTP",
  "settings_template_description": "I template sono lo strumento perfetto per creare email con un layout efficace.",
  "settings_template_enable": "Abilita questa funzione per impostare uno stile alle tue e-mail con il modello predefinito",
  "settings_template_slide_add": "Aggiungi un template",
  "settings_template_slide_default": "Predefinito",
  "settings_template_slide_description": "Uno strumento per aggiungere modelli specifici al layout della tua email.",
  "settings_template_slide_empty_description": "Clicca su 'Aggiungi template' e completa i campi con le informazioni richieste, includendo il nome del template, l’HTML o il testo semplice.",
  "settings_template_slide_empty_title": "Aggiungi un template",
  "settings_template_slide_html": "Versione HTML",
  "settings_template_slide_info": "Il tag <% body %> è obbligatorio nella versione HTML e nella versione testuale, verrà sostituito dal contenuto effettivo al momento dell'invio.",
  "settings_template_slide_name": "Nome del Template",
  "settings_template_slide_plaintext": "Versione testuale",
  "settings_template_slide_title": "Template",
  "settings_template_title": "Template",
  "settings_title": "Impostazioni",
  "settings_tracking": "Tracciamento",
  "settings_unsubscribe_description": "Aggiungi un link Unsubscribe (o annulla iscrizione) alle mail di testo o HTML. In questo modo gli utenti che si disiscrivono non riceveranno più le tue email.",
  "settings_unsubscribe_enable": "Abilita questa funzione per aggiungere un link di disiscrizione alle tue email",
  "settings_unsubscribe_select": "Seleziona una lingua",
  "settings_unsubscribe_slide_add": "Aggiungi link Unsubscribe",
  "settings_unsubscribe_slide_description": "Aggiungi un link Unsubscribe in fondo alle e-mail di testo e HTML. Nessuna e-mail verrà più inviata agli utenti disiscritti. Gli annullamenti delle iscrizioni verranno gestiti automaticamente e in tempo reale per migliorare la tua reputazione d’invio. Inserisci il testo che vuoi utilizzare (per esempio “Per annullare l’iscrizione clicca qui”) poi copia il testo nell’apposito spazio all’interno del messaggio. ",
  "settings_unsubscribe_slide_empty": "Aggiunge un collegamento di disisscrizione in fondo alle e-mail di testo e HTML.",
  "settings_unsubscribe_slide_empty_description": "Aggiungi un link Unsubscribe in fondo alle e-mail di testo e HTML. Nessuna e-mail verrà più inviata agli utenti disiscritti. Gli annullamenti delle iscrizioni verranno gestiti automaticamente e in tempo reale per migliorare la tua reputazione d’invio..",
  "settings_unsubscribe_slide_language": "Lingua",
  "settings_unsubscribe_slide_placeholder": "Segnaposto",
  "settings_unsubscribe_slide_text": "Testo Unsubscribe",
  "settings_unsubscribe_slide_title": "Link Unsubscribe",
  "settings_unsubscribe_text": "Testo",
  "settings_unsubscribe_title": "Link di Unsubscribe",
  "settings_unsubscribe_value": "Esempio: se vuoi disiscriverti, clicca questo link.",
  "settings_webhooks_description": "I Web-hook permettono alla tua app web di ricevere una notifica in tempo reale per ogni email consegnata o evento di interazione.",
  "settings_webhooks_slide_alert": "Eventuali modifiche applicate potrebbero richiedere fino a 1 ora per avere effetto.",
  "settings_webhooks_slide_bounced": "Rimbalzato",
  "settings_webhooks_slide_click": "Clic",
  "settings_webhooks_slide_deferred": "Rimandato",
  "settings_webhooks_slide_delivered": "Consegnato",
  "settings_webhooks_slide_deliveryevents": "Eventi di consegna",
  "settings_webhooks_slide_description": "Puoi usare I Web-hook di Notifica Eventi per rimanere aggiornato su tutti gli eventi che avvengono nel tuo progetto email senza l’uso delle API.",
  "settings_webhooks_slide_dropped": "Rilasciato",
  "settings_webhooks_slide_engagementevents": "Eventi di coinvolgimento",
  "settings_webhooks_slide_inserturl": "Inserisci qui l'url a cui vuoi essere notificato",
  "settings_webhooks_slide_notification": "URL di notifica Web-hook",
  "settings_webhooks_slide_notification_description": "Abilita le notifiche Web-hook",
  "settings_webhooks_slide_open": "Apri",
  "settings_webhooks_slide_placeholder": "http:// o https://",
  "settings_webhooks_slide_processed": "Elaborato",
  "settings_webhooks_slide_spamreport": "Rapporto spam",
  "settings_webhooks_slide_title": "Web-hook",
  "settings_webhooks_slide_unsubscribe": "Disiscrizione",
  "settings_webhooks_support": "Contatta il supporto clienti per richiedere l'attivazione degli Eventi di Consegna",
  "settings_webhooks_title": "Web-hook",
  "settings_webhooks_upgrade": "Fai un upgrade",
  "status_active": "Attivo",
  "status_inactive": "Inattivo",
  "status_cancelled": "Cancellato",
  "status_fraud": "Frode",
  "status_pending": "In attesa",
  "status_suspended": "Sospeso",
  "status_terminated": "Terminato",
  "subaccount_policy_agree": "Ho letto e accetto la <a href=\"https://serversmtp.com/it/norme-sulla-privacy-regolamento-ue-2016-79-gdpr/\" target=\"_blank\">informativa sulla privacy</a> e i <a href=\"https://serversmtp.com/it/termini-e-condizioni/\" target=\"_blank\">termini e condizioni</a> del servizio.",
  "subaccount_policy_agree_notchecked": "Devi accettare i termini di servizio e l'informativa sulla privacy",
  "subaccount_slide_inuse": "In uso",
  "subaccount_slide_ip": "IP",
  "subaccount_slide_ips": "Lista IP",
  "subaccount_slide_ips_description": "Per favore, seleziona un IP da assegnare a questo account secondario",
  "subaccount_slide_selectplan": "Seleziona un piano",
  "subaccount_slide_spf": "Record SPF",
  "subaccounts_action_activated": "{email} è stato attivato con successo",
  "subaccounts_action_active": "Attiva",
  "subaccounts_action_deactivated": "{email} è stato sospeso con successo",
  "subaccounts_action_delete": "Elimina",
  "subaccounts_action_deleted": "Sottoaccount eliminato con successo",
  "subaccounts_action_details": "Dettagli",
  "subaccounts_action_edit": "Modifica",
  "subaccounts_action_limit": "Limiti invio",
  "subaccounts_action_login": "Accedi",
  "subaccounts_action_notdeleted": "Errore durante l'eliminazione del subaccount",
  "subaccounts_action_suspend": "Sospendi",
  "subaccounts_active": "Attivo",
  "subaccounts_added_succesfully": "Il Sub-Account è stato aggiunto con successo",
  "subaccounts_agencysettings": "Impostazioni agenzia",
  "subaccounts_assigned_ip": "IP Assegnato",
  "subaccounts_changed_succesfully": "Il subaccount è stato modificato con successo",
  "subaccounts_confirm_activation_label": "Conferma attivazione",
  "subaccounts_confirm_activation_text": "Vuoi attivare {email}?",
  "subaccounts_confirm_deactivation_label": "Conferma disattivazione",
  "subaccounts_confirm_deactivation_text": "Vuoi sospendere {email}?",
  "subaccounts_confirm_delete_label": "Conferma eliminazione",
  "subaccounts_confirm_delete_text": "Vuoi eliminare il subaccount {email}?",
  "subaccounts_filter_ip": "Filtra per IP...",
  "subaccounts_filter_status": "Filtra per stato...",
  "subaccounts_search_placeholder": "Filtra per email...",
  "subaccounts_confirm_login_label": "Conferma accesso al Sub account",
  "subaccounts_confirm_login_text": "Sei sicuro di voler uscire dal account attuale per accedere a: <br><strong>{email}</strong>?",
  "subaccounts_confirmation": "Conferma",
  "subaccounts_create_warning": "La creazione di nuovi Sub Account è disponibile solo con gli \"abbonamenti Professional\".",
  "subaccounts_email": "Email account",
  "subaccounts_empty": "Amplia la tua attività e offri ai tuoi clienti un servizio professionale completamente personalizzabile, oppure dividi le tue email tra i tuoi dipendenti e colleghi.<br>Una semplice interfaccia di gestione ti consentirà di monitorare traffico e statistiche.",
  "subaccounts_expiration_date": "Data di scadenza",
  "subaccounts_filters_no_results": "I filtri applicati non hanno prodotto risultati",
  "subaccounts_inactive": "Inattivo",
  "subaccounts_ip": "IP",
  "subaccounts_last_activity": "Ultima attività",
  "subaccounts_limits_nolimits": "Illimitato",
  "subaccounts_limits_sending": "Limite di invio:",
  "subaccounts_limits_slide_description": "Imposta i limiti di invio per i tuoi Sub account.",
  "subaccounts_limits_slide_limits": "Limiti",
  "subaccounts_limits_slide_noplan_expiration": "Nessuna scadenza",
  "subaccounts_limits_slide_plan_expiration": "Scadenza piano",
  "subaccounts_limits_slide_set_plan_expiration": "Imposta scadenza:",
  "subaccounts_limits_slide_this_number": "Questo numero si riferisce a un periodo",
  "subaccounts_limits_slide_title": "Limiti Sub account",
  "subaccounts_logo_changed_success": "Logo dell'agenzia aggiornato con successo",
  "subaccounts_logo_changed_error": "Errore nel tentativo di aggiornare il logo dell'agenzia",
  "subaccounts_logo_reset_success": "Logo predefinito ripristinato con successo",
  "subaccounts_logo_reset_error": "Errore nel tentativo di ripristinare il logo predefinito",
  "subaccounts_no_expiration": "{master_expiration_date} <i class='pi pi-info-circle'></i>",
  "subaccounts_no_expiration_tooltip": "Basato sulla scadenza del piano dell'account principale.",
  "subaccounts_settings_update": "Le impostazioni del subaccount sono state aggiornate.",
  "subaccounts_slide_account_confirm": "Conferma i dati dell'account",
  "subaccounts_slide_account_description": "Clicca sul bottone Modifica per cambiare le informazioni del tuo Sub-Account.",
  "subaccounts_slide_account_info": "Informazioni sull'account",
  "subaccounts_slide_address": "Indirizzo",
  "subaccounts_slide_address2": "Indirizzo 2",
  "subaccounts_slide_change_password": "Imposta una password",
  "subaccounts_slide_city": "Città",
  "subaccounts_slide_company": "Azienda",
  "subaccounts_slide_confirm_password": "Conferma password",
  "subaccounts_slide_confirmpassword_different": "Assicurati che le due password siano uguali.",
  "subaccounts_slide_country": "Paese",
  "subaccounts_slide_email": "E-mail",
  "subaccounts_slide_email_not_unique": "Questo indirizzo email risulta già in uso.",
  "subaccounts_slide_email_required": "Un indirizzo email è richiesto.",
  "subaccounts_slide_first_name": "Nome",
  "subaccounts_slide_firstname_required": "Il campo Nome è richiesto.",
  "subaccounts_slide_last_name": "Cognome",
  "subaccounts_slide_lastname_required": "Il campo Cognome è richiesto.",
  "subaccounts_slide_password": "Password",
  "subaccounts_slide_password_details": "Lascia in bianco il campo password per continuare a utilizzare la password attuale.",
  "subaccounts_slide_password_minlength": "La password dovrebbe essere minimo di {req} caratteri, in questo momento è di: {act}.",
  "subaccounts_slide_password_required": "La password è richiesta.",
  "subaccounts_slide_password_pattern": "La password deve contenere almeno 10 caratteri, di cui almeno uno maiuscolo, uno minuscolo e una cifra",
  "subaccounts_slide_phone": "Telefono",
  "subaccounts_slide_profile_information": "Informazioni sul profilo",
  "subaccounts_slide_region": "Provincia",
  "subaccounts_slide_website": "Sito internet",
  "subaccounts_slide_zip": "Zip",
  "subaccounts_status": "Stato",
  "subaccounts_subaccounts": "Lista Sub Account",
  "subaccounts_title": "Sub Account",
  "subaccounts_unlimited": "Illimitato <i class='pi pi-info-circle'></i>",
  "subaccounts_unlimited_tooltip": "Basato sul limite del piano dell'account principale.",
  "subaccounts_usage": "Utilizzo",
  "sunday": "Domenica",
  "suppression_deleted": "I contatti in blacklist saranno eliminati a breve.",
  "suppression_filters_reason": "Motivo",
  "suppression_filters_recipient": "Destinatario",
  "suppression_filters_sender": "Mittente",
  "suppression_filters_sources": "Fonti",
  "suppression_filters_subject": "Oggetto dell'email",
  "suppression_operators_exclude": "Escludi",
  "suppression_operators_include": "Includi",
  "suppression_table_addcolumn_sender": "Mittente",
  "suppression_table_dropdown_text": "{first} — {last} di {totalRecords}",
  "suppression_types_bounce": "Bounce",
  "suppression_types_manual": "Manuale",
  "suppression_types_spam": "Spam",
  "suppression_types_unsubscribe": "Disiscritti",
  "suppression_types_validation_failed": "convalida non riuscita",
  "suppressions_add_form_errors": "Errori di modulo",
  "suppressions_add_form_nofile_selected": "Nessun file selezionato",
  "suppressions_add_suppression": "Importa contatti",
  "suppressions_choose_columns": "Scegli colonne",
  "suppressions_confirm_delete_all_label": "Conferma azione",
  "suppressions_confirm_delete_all_text": "Sei sicuro di voler eliminare tutte le email in blacklist da <strong>{from}</strong> al <strong>{to}</strong>?",
  "suppressions_confirm_delete_all_type_text": "Sei sicuro di voler eliminare tutte le email in blacklist <br> di tipo <strong>{type}</strong> dal <strong>{from}</strong> al <strong>{to}</strong>?",
  "suppressions_confirm_delete_filtered_label": "Conferma azione",
  "suppressions_confirm_delete_filtered_text": "Vuoi davvero eliminare tutti gli <strong>elementi in blacklist filtrati</strong>?<br><small>*I recalami Spam non verranno eliminati.</small>",
  "suppressions_confirm_delete_selected_label": "Conferma azione",
  "suppressions_confirm_delete_selected_text": "Vuoi davvero eliminare gli elementi in blacklist selezionati?",
  "suppressions_date": "Data",
  "suppressions_delete_all": "Elimina tutto",
  "suppressions_delete_selected": "Elimina selezionati",
  "suppressions_deleted": "Gli indirizzi in blacklist saranno eliminati a breve.",
  "suppressions_description": "Una elemento nella blacklist è un indirizzo e-mail o un dominio a cui è impedito di ricevere ulteriori e-mail. Gli indirizzi e-mail in questa pagina sono hard bounce, reclami di spam, cancellazioni e inserimenti manuali.",
  "suppressions_description_empty": "Non sono stati trovati risultati per i criteri selezionati.",
  "suppressions_details_date": "Data",
  "suppressions_details_entry": "Entry",
  "suppressions_details_reason": "Motivo",
  "suppressions_details_sender": "Mittente",
  "suppressions_details_subject": "Oggetto",
  "suppressions_details_title": "Dettagli",
  "suppressions_details_type": "Tipo",
  "suppressions_event_history": "Cronologia eventi",
  "suppressions_imported": "Le email saranno importate a breve nella blacklist.",
  "suppressions_imported_partial": "{imported} / {total} saranno presto importate nella blacklist.",
  "suppressions_include": "Includi",
  "suppressions_modal_confirm": "Conferma",
  "suppressions_not_imported": "Non verranno importate nella blacklist a causa di email non corrette.",
  "suppressions_reason": "Motivo",
  "suppressions_recipient": "Destinatario",
  "suppressions_title": "Blacklist",
  "suppressions_title_empty": "Nessun contatto è stato trovato nella blacklist.",
  "suppressions_type": "Tipo",
  "t_api": "Documentazione API",
  "t_knowledgebase": "Documentazione",
  "t_logout": "Esci",
  "t_newsupdates": "Notizie e aggiornamenti",
  "t_search": "Cerca",
  "t_support": "Supporto",
  "t_username": "Nome utente",
  "table_dropdown_goto": "Vai alla pagina",
  "table_dropdown_text": "{first} — {last} di {totalRecords}",
  "thursday": "Giovedi",
  "tickets_description_empty": "Il sistema di ticket di supporto ci consente di rispondere ai tuoi problemi e alle tue richieste il più rapidamente possibile. Quando rispondiamo al tuo ticket di supporto, riceverai una notifica via e-mail.",
  "tickets_title_empty": "Apri un nuovo ticket di supporto",
  "toggle_off": "Disabilitato",
  "toggle_on": "Attivato",
  "token_can_not_be_empty": "Il token non può essere vuoto",
  "token_is_missing": "Token mancante",
  "tuesday": "Martedì",
  "unlimited": "illimitato",
  "upload_add_manually": "Aggiungi manualmente",
  "upload_add_manually_description": "Copia e incolla più indirizzi email nell'area sottostante, separandoli da un a capo. Per ricordare perché hai aggiunto i contatti e per aiutare le ricerche future, aggiungi una \"motivo\".",
  "upload_add_reason": "Inserisci un motivo per eliminare questi indirizzi",
  "upload_allowed_files": "I formati aupportati sono csv o txt.",
  "upload_dd_here": "Trascina e rilascia il file qui ",
  "upload_formats": "Formati file",
  "upload_import_from_file": "Importa da un file",
  "upload_import_from_file_description": "Il file deve contenere una colonna con gli indirizzi email che desideri importare. Per ricordare il motivo per cui hai aggiunto i contatti e per facilitare le ricerche future, aggiungi una \"motivo\".",
  "wednesday": "Mercoledì",
  "whitelabel_agencyname": "Nome agenzia",
  "whitelabel_companydetails": "Dati dell'impresa",
  "whitelabel_description": "Se hai aperto un subaccount e sei un rivenditore ufficiale turboSMTP, probabilmente vorrai personalizzare il prodotto con il tuo logo e le informazioni aziendali, per far capire che sei l'unico referente per i tuoi clienti e per fornirli un'esperienza di marca.",
  "whitelabel_footer": "Footer dashboard agenzia",
  "whitelabel_footer_description": "Inserisci il codice HTML da visualizzare nella pagina del footer.",
  "whitelabel_logo": "Logo aziendale",
  "whitelabel_logo_description": "Dimensione massima dell'immagine 472 x 72 px.",
  "whitelabel_reset_default_image": "Ripristina immagine predefinita",
  "whitelabel_upload_image": "Carica immagine",
  "whitelabel_upload_in_progress": "Caricamento in corso",
  "whitelabel_website": "Sito web dell'agenzia",
  "wrong_credentials_specified": "Le credenziali specificate sono errate.",
  "yes": "Si",
  "missing_required_parameter_amount": "Non è stato inserito l'importo",
  "amount_should_be_integer": "L'importo deve essere un numero intero",
  "amount_should_not_be_less_than_15": "L'importo non può essere minore di 15",
  "amount_should_not_be_higher_than_1800": "L'importo non può essere maggiore di 1800",
  "missing_settings_required": "Alcune impostazioni sono richieste per abilitare questa opzione",
  "settings_apikeys_title": "Chiavi API",
  "settings_apikeys_description": "Le chiavi API sono uno strumento altamente sicuro per collegare i servizi turboSMTP alle tue applicazioni. Puoi revocare l'accesso in qualsiasi momento.",
  "settings_apikeys_slide_title": "Chiavi API",
  "settings_apikeys_slide_description": "Gestisci le tue chiavi API. Questa tabella mostra tutte le tue chiavi API attive. Puoi creare nuove chiavi o eliminare le chiavi esistenti per revocarne l'accesso.",
  "settings_apikeys_slide_empty_title": "Crea chiave API",
  "settings_apikeys_slide_empty_description": "Le chiavi API sono composte da Consumer Key e Consumer Secret. Sono credenziali software che consentono a un programma di accedere al tuo account turboSMTP senza usare il tuo nome utente e la tua password. Sono altamente sicure e possono essere revocate in qualsiasi momento, senza modificare le tue credenziali di accesso al pannello di controllo turboSMTP.",
  "settings_apikeys_slide_add": "Crea chiave API",
  "settings_apikeys_slide_add_description": "Scegli un nome di riferimento per la tua chiave API.",
  "settings_apikeys_apikey_name": "Nome",
  "settings_apikeys_slide_label_info": "Questo nome è solo un riferimento. Non dovrai inserire il nome nelle tue app.",
  "settings_apikeys_apikey_key": "Consumer Key",
  "settings_apikeys_apikey_creationtime": "Data di creazione",
  "settings_apikeys_apikey_name_label": "Nome chiave API",
  "settings_apikeys_apikey_name_placeholder": "Imposta il nome della tua chiave API",
  "settings_apikeys_apikey_edit_alt": "Modifica chiave API",
  "settings_apikeys_apikey_revoke_alt": "Elimina e revoca",
  "settings_apikeys_apikey_confirm_revoke_label": "Elimina e revoca la chiave API",
  "settings_apikeys_apikey_confirm_revoke_text": "Eliminare la chiave API \"{name}\"?<br>Verrà revocato l'accesso per tutte le app che usano questa chiave.",
  "settings_apikeys_apikey_confirm_revoke_confirm": "Conferma",
  "settings_apikeys_apikey_confirm_revoke_cancel": "Annulla",
  "settings_apikeys_apikey_revoked": "Chiave API revocata con successo",
  "settings_apikeys_apikey_consumerkey_button_add": "Genera chiave API",
  "settings_apikeys_apikey_consumerkey_button_save": "Salva modifiche",
  "settings_apikeys_slide_edit_description": "Modifica i dettagli della chiave API qui sotto.",
  "settings_apikeys_apikey_updated": "Chiave API aggiornata con successo",
  "settings_apikeys_apikey_new_success": "Chiave API creata!",
  "settings_apikeys_apikey_consumer": "Consumer Key",
  "settings_apikeys_apikey_secret": "Consumer Secret",
  "settings_apikeys_apikey_new_security": "Questa <strong>Consumer Secret</strong> è mostrata solo qui. <strong>Copiala ora e tienila al sicuro</strong>. Se perdi questa chiave, dovrai eliminarla e generarne una nuova.",
  "settings_apikeys_restrict_ip_label": "Limita la chiave API a IP specifici",
  "settings_apikeys_restrict_ip_description": "Quando abilitato, questa chiave API funzionerà solo dagli indirizzi IP specificati.",
  "settings_apikeys_allowed_ips_label": "Indirizzi IP consentiti",
  "settings_apikeys_ip_placeholder": "Inserisci indirizzo IP (es. 8.8.8.8)",
  "settings_apikeys_add_ip": "Aggiungi indirizzo IP",
  "settings_apikeys_remove_ip": "Rimuovi indirizzo IP",
  "settings_apikeys_ip_required": "L'indirizzo IP è richiesto",
  "settings_apikeys_ip_invalid": "Inserisci un indirizzo IP valido",
  "settings_apikeys_allowed_ips": "IP consentiti:",
  "settings_apikeys_permissions_label": "Permessi API",
  "settings_apikeys_permissions_placeholder": "Seleziona permessi",
  "settings_apikeys_permissions_description": "Scegli quali servizi può utilizzare questa chiave API.",
  "settings_apikeys_permission_send_smtp": "Invio SMTP",
  "settings_apikeys_permission_send_api": "Invio HTTP API",
  "settings_apikeys_permission_apis": "Statistiche e API di gestione",
  "settings_apikeys_permissions_required": "Seleziona almeno un'opzione",
  "settings_apikeys_legacy_key_alert_message": "Abbiamo aggiornato la nostra <strong>autenticazione SMTP</strong> per utilizzare le <strong>chiavi API</strong> al posto della password del tuo account.<br>Per garantire una transizione senza problemi, <strong>abbiamo creato una chiave API speciale</strong> per te che corrisponde alle tue vecchie credenziali. Per una maggiore sicurezza, ti consigliamo vivamente di <strong>eliminare questa chiave e crearne una nuova</strong> da usare nelle tue impostazioni SMTP.",
  "settings_apikeys_legacy_key_alert_link": "Maggiori informazioni",
  "settings_apikeys_legacy_key_alert_link_href": "https://serversmtp.com/it/aggiornamento-di-sicurezza-passaggio-utenticazione-tramite-chiavi-api/",
  "settings_apikeys_ips_label": "Restrizione IP",
  "settings_bccs_missing_required": "Assicurati di impostare un BCC come predefinito prima di abilitare questa opzione",
  "settings_bccs_notifications_default": "Email BCC predefinita aggiornata con successo",
  "settings_link_branding_enable": "Attiva per utilizzare i tuoi domini di tracciamento",
  "settings_link_branding_missing_required": "Inserisci e verifica almeno un dominio per attivare la funzionalità",
  "settings_link_branding_title": "Domini di Tracking Personalizzati",
  "settings_link_branding_description": "Utilizza i tuoi domini per \"Open Tracking\" e \"Click Tracking\" invece di quelli di TurboSMTP",
  "settings_link_branding_box_alert": "Queste impostazioni non avranno effetto se l'Open Tracking e il Click Tracking sono disabilitati",
  "settings_link_branding_empty_description": "Clicca su \"Aggiungi dominio di tracciamento\" e compila i campi con le informazioni richieste...",
  "settings_link_branding_empty_title": "Aggiungi dominio di tracciamento",
  "settings_link_branding_add_domain": "Aggiungi dominio di tracciamento",
  "settings_link_branding_add_domain_info": "Inserisci il tuo dominio e modifica eventuali opzioni avanzate",
  "settings_link_branding_advanced": "Opzioni avanzate",
  "settings_link_branding_custom_subdomain": "Sottodominio personalizzato",
  "settings_link_branding_custom_subdomain_tooltip": "Inserire un nome di dominio valido prima di specificare un sottodominio personalizzato",
  "settings_link_branding_custom_subdomain_info": "Il sistema genererà automaticamente un sottodominio casuale. Se desideri utilizzarne uno specifico, inseriscilo qui",
  "settings_link_branding_button_add": "Aggiungi dominio di tracciamento",
  "settings_link_branding_match": "Abbina il dominio di tracciamento al dominio del mittente",
  "settings_link_branding_match_sender_disabled": "Abbinamento domini disabilitato",
  "settings_link_branding_match_sender_enabled": "Abbinamento domini abilitato",
  "settings_link_branding_filters_no_results": "I filtri applicati non hanno prodotto risultati",
  "settings_link_branding_search_placeholder": "Filtra i domini per nome...",
  "settings_link_branding_verification_placeholder": "Verifica...",
  "settings_link_branding_verified": "Verificato",
  "settings_link_branding_click_to_verify": "PENDING. La configurazione del CNAME per questo dominio non è stata completata o verificata. Fai clic per procedere...",
  "settings_link_branding_verification_success": "Verifica riuscita",
  "settings_link_branding_verification_domain_not_found": "Dominio non trovato",
  "settings_link_branding_verification_cname_not_found": "Il CNAME del sottodominio {track_dns} non è stato trovato",
  "settings_link_branding_verification_auth_cname_not_found": "Il CNAME del sottodominio {auth_dns} non è stato trovato",
  "settings_link_branding_verification_multiple_cname_found": "Sono stati trovati più record CNAME per il sottodominio {track_dns}",
  "settings_link_branding_verification_auth_multiple_cname_found": "Sono stati trovati più record CNAME per il sottodominio {auth_dns}",
  "settings_link_branding_verification_incorrect_cname_target": "Il CNAME del sottodominio {track_dns} ha un valore errato",
  "settings_link_branding_verification_auth_incorrect_cname_target": "Il CNAME del sottodominio {auth_dns} ha un valore errato",
  "settings_link_branding_enabled": "Abilitato",
  "settings_link_branding_disabled": "Disabilitato",
  "settings_link_branding_not_verified": "Pending",
  "settings_link_branding_name": "Nome del dominio",
  "settings_link_branding_enabled_no": "Dominio di tracciamento disabilitato",
  "settings_link_branding_enabled_yes": "Dominio di tracciamento attivo",
  "settings_link_branding_default_enabled": "Dominio di tracciamento impostato come non dedicato",
  "settings_link_branding_default_disabled": "Dominio di tracciamento impostato come dedicato",
  "settings_link_branding_subdomain_name_invalid": "Il sottodominio non è valido",
  "settings_link_branding_domain_name_invalid": "Nome di dominio non valido",
  "settings_link_branding_confirm_delete_label": "Elimina dominio di tracciamento",
  "settings_link_branding_confirm_delete_text": "Vuoi davvero cancellare questo dominio di tracciamento?",
  "invalid_domain_name": "Nome di dominio non valido",
  "settings_link_branding_exclusivity_placeholder": "È dedicato...",
  "settings_link_branding_exclusive": "Dedicato",
  "settings_link_branding_not_exclusive": "Non dedicato",
  "settings_link_branding_domain_name": "Dominio di tracciamento",
  "settings_link_branding_domain_status": "Stato",
  "settings_link_branding_added": "Dominio aggiunto con successo",
  "settings_link_branding_removed": "Dominio rimosso con successo",
  "settings_link_branding_default_match_help": "I domini dedicati sono utilizzati esclusivamente con dominio mittente corrispondente. Non sono mai utilizzati con domini mittente non corrispondenti",
  "settings_link_branding_dns_info": "Per completare il processo è necessario installare i seguenti record DNS nel proprio hosting.",
  "settings_link_branding_ssl_verify": "Non è possibile verificare la configurazione dei domini SSL dalla dashboard. Per maggiori informazioni, ti invitiamo a contattare il supporto tecnico.",
  "settings_link_branding_dns_wait": "Possono essere necessarie fino a 24 ore perché le modifiche ai record DNS abbiano effetto",
  "settings_link_branding_dns_info_host": "Aggiungi questi due record alla sezione DNS del tuo hosting",
  "settings_link_branding_dns_type": "Tipo",
  "settings_link_branding_dns_host": "Host",
  "settings_link_branding_dns_host_help": "Alcuni hosting DNS possono riferirsi a questo valore come \"Dominio\" o \"Nome\"",
  "settings_link_branding_dns_value": "Valore",
  "settings_link_branding_dns_value_help": "Alcuni hosting DNS possono riferirsi a questo valore come \"Data\"",
  "settings_link_branding_dns_help": "Non sei sicuro di come fare?",
  "settings_link_branding_dns_help_link": "Consulta la documentazione",
  "settings_link_branding_dns_verification_tooltip": "Questo record CNAME è lo stesso per tutti i sottodomini del dominio. Deve essere aggiunto una sola volta: se già presente, non è necessario aggiungerlo",
  "settings_link_branding_verify_description": "Una volta aggiunti i record DNS, clicca sul bottone \"Verifica\"",
  "settings_link_branding_verify_button": "Verifica",
  "settings_link_branding_delete_info": "Non hai più bisogno di questo dominio di tracciamento?",
  "settings_link_branding_delete_button": "Elimina il dominio",
  "settings_link_branding_security_placeholder": "Sicurezza...",
  "settings_link_branding_https": "HTTPS",
  "settings_link_branding_http": "HTTP",
  "settings_link_branding_button_ok": "Ok",
  "settings_link_branding_status_placeholder": "Stato...",
  "settings_link_branding_status_enabled_no": "Disabilitato",
  "settings_link_branding_status_enabled_yes": "Attivo",
  "settings_link_branding_all_domains_disabled": "Se tutti i domini personalizzati sono disabilitati o in pending, verranno utilizzati i link di tracciamento standard di turboSMTP",
  "settings_link_branding_no_default_domain": "Se tutti i link di tracciamento attivi sono dedicati, i mittenti con domini disabilitati o non presenti in questo elenco utilizzeranno i link di tracciamento standard di turboSMTP",
  "settings_link_branding_match_modal_cancel": "Annulla",
  "settings_link_branding_match_modal_confirm": "Ok",
  "settings_link_branding_match_title": "Rotazione dei domini",
  "settings_link_branding_match_change": "Cambia questo comportamento",
  "settings_link_branding_match_enabled_title": "Abbina al dominio del mittente",
  "settings_link_branding_match_disabled_title": "Non abbinare al dominio del mittente",
  "settings_link_branding_match_enabled_info": "Se il dominio del mittente corrisponde a uno dei domini di tracking attivi, verrà utilizzato quel dominio.<br> Se il dominio del mittente non corrisponde a nessun dominio di tracking, verrà usato uno dei domini di tracciamento attivi (esclusi duelli \"Dedicati\").",
  "settings_link_branding_match_disabled_info": "Verrà utilizzato uno dei domini di tracking attivi, indipendentemente da quale sia il dominio del mittente.",
  "config_server_error": "La dashboard è in fase di manutenzione, riprova tra qualche minuto",
  "feature_not_available_for_active_plan": "Questa funzionalità non è inclusa in alcuno dei tuoi piani",
  "display_auto_mode": "auto",
  "display_dark_mode": "scuro",
  "display_font_size": "Dimensione testo",
  "display_large": "grande",
  "display_layout_mode": "Tema",
  "display_light_mode": "chiaro",
  "display_medium": "medio",
  "display_settings": "Visualizzazione",
  "display_small": "piccolo",
  "m_home": "Home",
  "suppressions_subject": "Oggetto",
  "warning_lang": "",
  "forgot_password_use_different_password": "Si prega di creare una nuova password diversa dalle password precedenti per migliorare la sicurezza del proprio account.",
  "m_getting_started": "Primi passi",
  "settings_sender_title": "Verifica domini mittente",
  "settings_sender_add_domain": "Aggiungi dominio",
  "settings_sender_description": "Per migliorare il tasso di consegna delle tue email, autentica i tuoi domini mittente impostando pochi record DNS.",
  "settings_sender_domains_empty": "Non è presente alcun dominio mittente.<br>Inserisci e verifica il tuo primo dominio.",
  "settings_sender_if_unverified": "Cosa succede se il dominio mittente non è verificato?",
  "settings_sender_notify_label": "Notificami via email se il dominio del mittente non è verificato",
  "settings_sender_notify_email_label": "Indirizzo email",
  "settings_sender_notify_email_tip": "Se vuoto, l'email di notifica sarà inviata all'indirizzo dell'account turboSMTP.",
  "settings_sender_notify_email_error": "Si prega di inserire un indirizzo email valido",
  "settings_sender_notify_email_placeholder": "Inserisci un indirizzo email...",
  "settings_sender_dns_title": "Come verificare il tuo dominio",
  "settings_sender_dns_description": "Per il nostro servizio SMTP, è necessario impostare i record SPF e DKIM per i tuoi domini mittente. Aggiungere anche un record DMARC è obbligatorio per una maggiore sicurezza e affidabilità delle email.",
  "settings_sender_spf_title": "Record SPF",
  "settings_sender_spf_description": "Procedere impostando il record TXT specificato al dominio mittente, scegliendo tra una delle seguenti due alternative:",
  "settings_sender_dkim_title": "Record DKIM",
  "settings_sender_dkim_description": "Per il DKIM, aggiungi il record TXT fornito alle impostazioni DNS del tuo dominio, che contiene la chiave pubblica utilizzata per verificare che le email inviate dal tuo dominio siano legittime e non siano state alterate durante il transito.",
  "settings_sender_dmarc_title": "Record DMARC",
  "settings_sender_dmarc_description": "Completa il processo di autenticazione dell'email aggiungendo il record TXT DMARC fornito al tuo DNS, stabilendo una politica su come i destinatari delle email dovrebbero trattare i messaggi che non superano i controlli SPF o DKIM, fornendo così un ulteriore livello di difesa contro le pratiche email fraudolente.",
  "settings_sender_domain_added": "Dominio mittente <strong>{domain}</strong> aggiunto.",
  "settings_sender_domain": "Dominio mittente",
  "settings_sender_domains_name": "Nome dominio",
  "settings_sender_domains_action": "",
  "settings_sender_domains_action_verify": "Verifica",
  "settings_sender_domains_action_delete": "Elimina",
  "settings_sender_domains_action_subaccount": "Subaccount:",
  "settings_sender_action_delete_confirm_title": "Elimina dominio",
  "settings_sender_action_delete_confirm_message": "Sei sicuro di voler eliminare il dominio <strong>{domainName}</strong>?",
  "settings_sender_domain_description": "Specifica il dominio del mittente che desideri validare:",
  "settings_sender_verify_record": "Record TXT",
  "settings_sender_verify_value": "Stato",
  "settings_sender_verify_ok": "Ok",
  "settings_sender_dns_ask_admin": "Si prega di contattare il tuo account manager per verificare il dominio. Questa azione è necessaria e può essere eseguita solo dal titolare dell'account principale.",
  "settings_sender_verify_fail": "{type} non trovato o non configurato correttamente",
  "settings_sender_verified": "Il tuo dominio è configurato correttamente. Puoi inviare in sicurezza usando questo mittente.",
  "settings_sender_dkim_domain_title": "Dominio DKIM",
  "settings_sender_dkim_value_title": "Valore DKIM",
  "settings_sender_dmarc_domain_title": "Dominio DMARC",
  "settings_sender_dmarc_value_title": "Valore DMARC",
  "settings_sender_domains_search_placeholder": "Filtra i domini mittente per nome...",
  "settings_sender_domains_status_placeholder": "Verifica...",
  "settings_sender_domains_status_verified": "Verificati",
  "settings_sender_domains_status_not_verified": "Non verificati",
  "settings_sender_domains_filters_no_results": "I filtri applicati non hanno prodotto risultati",
  "block_unverified_sender_title": "Blocca i domini mittente non verificati",
  "block_unverified_sender_modal_title": "Domini mittente non verificati",
  "block_unverified_sender_desc": "Se il dominio mittente non è verificato, blocca l'invio delle email e notificami via email",
  "block_unverified_sender_change": "Modifica questo comportamento",
  "forward_as_received_title": "Invia senza modifiche",
  "forward_as_received_info": "Invia le tue email senza modifiche, anche da domini di invio non verificati. Considera che ciò potrebbe comportare un <strong>alto tasso di bounce e basso tasso di consegna</strong> poiché le tue email potrebbero essere segnalate come SPAM, influenzando la reputazione del tuo dominio.",
  "block_title": "Rifiuta e scarta",
  "block_info": "Le email da domini di invio non verificati non vengano inviate e vengono scartate. I messaggi che non superano i controlli SPF, DKIM o DMARC saranno automaticamente scartati per <strong>mantenere alta la tua reputazione di invio</strong> ed evitare il rischio di essere contrassegnati come SPAM.",
  "fallback_to_turbo_title": "Cambia il mittente",
  "fallback_to_turbo_info": "Utilizzeremo un indirizzo turboSMTP come mittente per le email da domini di inivio non verificati. Ciò può migliorare il tasso di consegna, anche se <strong>il cambio di indirizzo del mittente potrebbe essere visibile ai destinatari</strong> nei loro client di posta elettronica.",
  "notification_email_updated": "L'email di notifica è stata aggiornata.",
  "notification_email_enabled": "Email di notifica abilitata.",
  "notification_email_disabled": "Email di notifica disabilitata.",
  "invalid_notification_email": "Fornito un indirizzo email di notifica non valido.",
  "settings_sender_domains_new_intro": "Inserisci le informazioni del nuovo dominio mittente.",
  "paginator_page": "Pagina",
  "paginator_of": "di",
  "no_records_found": "Record DNS non trovato. Assicurati che il record sia pubblicato correttamente e che la propagazione sia completata.",
  "invalid_record_found": "È stato trovato un record DNS, ma sembra essere formattato in modo incorretto o avere un valore non valido.",
  "too_many_dns_lookups": "Il record SPF include più del limite consentito di 10 lookup DNS, il che può causare problemi di consegna delle email.",
  "more_than_spf_entry_found": "Sono stati rilevati più record SPF per il tuo dominio. È permesso un solo record SPF per dominio.",
  "settings_sender_loading_domain_data": "Caricamento dei risultati della verifica del dominio...",
  "notice": "Avviso",
  "settings_sender_domains_no_option": "Il tuo account è attualmente in esecuzione nella vecchia \"modalità standard\", il che significa che tutte le email verranno inviate utilizzando uno dei nostri indirizzi email, a prescindere dalla configurazione SPF, DKIM e DMARC.\nPer migliorare i tassi di consegna, si prega di selezionare una delle nuove opzioni di fallback.",
  "failed_to_get_a_aaaa_record": "Impossibile ottenere il record A / AAAA per il dominio {domain_name}",
  "invalid_spf_syntax": "Sintassi SPF non valida",
  "spf_has_upper_case_letters": "Il record SPF non deve contenere lettere maiuscole. Assicurarsi che tutti i caratteri siano in minuscolo per conformarsi alle specifiche SPF.",
  "recursive_include_detected": "Il record SPF non dovrebbe includere il dominio stesso poiché ciò crea un loop che porta a lookup DNS infiniti. Si prega di rivedere il record SPF rimuovendo il riferimento al dominio principale.",
  "spf_longer_than_255_characters": "L'SPF supera il limite di 255 caratteri per singolo record DNS. Per aderire alle specifiche DNS, si prega di dividere il record SPF in più stringhe, ciascuna non superiore a 255 caratteri, o di accorciare il record esistente.",
  "ptr_mechanism_not_allowed": "Per ottimizzare le prestazioni di SPF e promuovere l'adozione di pratiche di verifica del mittente più efficienti, è consigliabile evitare il meccanismo \"ptr:\" e affidarsi invece a meccanismi come \"ip4:\" e \"include:\".",
  "data_location_modal_title": "Ubicazione dei dati",
  "data_location_network_servers": "Server di rete",
  "data_location_ip_location": "Localizzazione IP",
  "data_location_company_managing_data": "Azienda che gestisce i dati",
  "data_location_network_servers_value": "Milano (IT), Francoforte (DE), Amsterdam (NL)",
  "data_location_ip_location_value": "Europa RI.PE",
  "data_location_company_managing_data_value": "Edisplay Srl, Italia UE",
  "data_location_no_transfer_outside_eu": "Nessun dato viene trasferito fuori dall'Unione Europea",
  "gdpr_data_location": "Dati in UE",
  "gdpr_see_details": "Dettagli",
  "not_included_in_plan": "Non incluso nel tuo piano attuale",
  "registration_logout": "Esci",
  "registration_step_personal": "Info Personali",
  "registration_step_company": "Info Azienda",
  "registration_step_address": "Indirizzo",
  "registration_label_email": "Email",
  "registration_label_firstname": "Nome",
  "registration_label_lastname": "Cognome",
  "registration_label_company": "Azienda",
  "registration_label_vat": "Partita IVA",
  "registration_label_vat_optional": "(Opzionale)",
  "registration_label_phone": "Numero di Telefono",
  "registration_label_website": "Sito Web",
  "registration_label_website_hint": "(Opzionale)",
  "registration_label_address": "Indirizzo",
  "registration_label_city": "Città",
  "registration_label_country": "Paese",
  "registration_placeholder_country": "Seleziona Paese",
  "registration_label_region": "Stato / Regione",
  "registration_placeholder_region": "Seleziona Regione",
  "registration_label_zip": "CAP",
  "registration_btn_back": "Indietro",
  "registration_btn_next": "Passaggio Successivo",
  "registration_btn_complete": "Completa Profilo",
  "registration_error_firstname": "Il nome è obbligatorio.",
  "registration_error_lastname": "Il cognome è obbligatorio.",
  "registration_error_company": "L'azienda è obbligatoria.",
  "registration_error_phone": "Il numero di telefono è obbligatorio.",
  "registration_error_website": "Inserisci un URL valido.",
  "registration_error_address": "L'indirizzo è obbligatorio.",
  "registration_error_city": "La città è obbligatoria.",
  "registration_error_country": "Il paese è obbligatorio.",
  "registration_error_region": "La regione è obbligatoria.",
  "registration_error_zip": "Il CAP è obbligatorio.",
  "registration_error_phone_format": "Il numero di telefono deve contenere solo numeri.",
  "registration_address_message": "Assicurandoti che il tuo indirizzo postale sia corretto, potrai beneficiare di un'<strong>esperienza di attivazione accelerata</strong>.",
  "registration_step_confirmation": "Conferma",
  "registration_confirmation_title": "Profilo completato!",
  "registration_confirmation_message": "Il tuo account è stato creato con successo.<br>Ora puoi acquistare un piano per sbloccare funzioni avanzate e avere limiti di invio superiori",
  "registration_confirmation_message_buy": "Il tuo account è stato creato con successo.",
  "registration_btn_buy_plan": "Acquista un piano",
  "registration_stay_free": "Resta con la versione gratuita, potrai fare l'upgrade in seguito",
  "registration_btn_dashboard": "Vai alla Dashboard",
  "registration_redirect_to_shop": "Sarai reindirizzato alla procedura di acquisto tra un momento...",
  "registration_go_to_shop": "Oppure clicca qui per procedere",
  "button_yes_delete": "Sì, elimina",
  "button_yes_revoke": "Sì, revoca"
}
